import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactImageVideoLightbox from 'react-image-video-lightbox';
import Cropper from 'react-cropper';
import Modal from 'react-modal';
import { Line } from 'rc-progress';
import { Link, useHistory } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactReadMoreReadLess from 'react-read-more-read-less';
import userProfile from '../../../assets/images/dummy-profile-pic.jpg';
import CoverImage from '../../../assets/images/dummy-image-landscape.jpg';

import auth from '../../../helpers/auth';
import banner from '../../../assets/images/dummy-image-landscape.jpg';
import settingicon from '../../../assets/images/settings-small.png';
import Input from '../../../components/Input/Input';
import Textarea from '../../../components/Textarea/Textarea';
import Checkbox from '../../../components/Checkbox/Checkbox';
import Select from '../../../components/Select/Select';
import Terms from '../../../components/Terms/Terms';
import MultiSelecter from '../../../components/MutiSelect/MultiSelect';
import FormError from '../../../components/Errors/FormError';
import SuccessMessage from '../../../components/Success/SuccessMessage';
import FormSpinner from '../../../components/Spinners/FormSpinner';
import PasswordIndicator from '../../../components/PasswordIndicator/PasswordIndicator';
import Map from '../../../components/Map/Map_google';
import '../../../assets/cropper.css';
import { getRegion, getCity } from '../../register/modules/register';
import { EditContact } from '../../contact/components/editContact';
import constant from '../../../helpers/constant';
import BlogView from './BlogView';
import TripView from './TripView';
import EventView from './EventView';
import { fetchAllUserPost } from '../../Post/modules/post';
import AwardView from './AwardView';
import firebase from '../../../config/firebase';
import language from '../../../helpers/language';
import ContentLoader from 'react-content-loader';
import $ from 'jquery';

import { Contact } from '../../contact/components/contacts';
import { UserSocialPost } from '../../Post/components/UserSocialPost';

import {
  memberProfileData,
  updateProfile,
  profileProgress,
  featureProductList,
  addFeatureProductList,
  deleteFeatureProductList,
  profileFormField,
  setFieldValues,
  changeAvatarCover,
  setFormErrors,
  setUploadImageErrors,
  visitorProfileData,
  updateProfileFeatureProductData,
  setClearFeatureProductValue,
  userFieldUpdate,
  setProfileTabIndex,
  getUserProfileFormField,
} from '../modules/profile';


export function ProfileView(props) {
  const EditRef = useRef();
  const featureProductRef = useRef(null);
  const [phone, setPhone] = useState('');
  const [openModel, setOpenModel] = useState(false);
  const [tabModel, setTabModel] = useState(false);
  const [editModel, setEditModel] = useState(false);
  const [editModelAbout, setEditModelAbout] = useState(false);
  const [editContactModel, setEditContactModel] = useState(false);
  const [tabTitle, setTabTitle] = useState();
  const [avatarTabModel, setAvatarTabModel] = useState(false);
  const [coverTabModel, setCoverTabModel] = useState(false);
  const [changeProfile, setchangeProfile] = useState(false);
  const [featureProductTabModel, setfeatureProductTabModel] = useState(false);
  const [hubSelectionTabModel, setHubSelectionTabModel] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [textAreaValues, setTextAreaValues] = useState('');
  const [textAreaId, setTextAreaId] = useState('');
  const [textAreaState, setTextAreaState] = useState(false);
  const [contactInfo, setContactInfo] = useState(false);
  const [isUrlStatus, setIsUrlStatus] = useState(false);
  const [lang] = useState(language.getLang());
  const [contactModel, setcontactModel] = useState(false);
  const [Pickup, setPickup] = useState(false);
  const [delevery, setDelevery] = useState(false);
  const [specialChar, SetSpecialChar] = useState(false);
  const [digits, SetDigits] = useState(false);
  const [strLength, SetStrLength] = useState(false);
  const [otherCity, SetotherCity] = useState(false);
  const [ConservationMethod, SetConservationMethod] = useState(false);
  const [Property, SetProperty] = useState(false);
  const [featureProductUpdate, setFeatureProductUpdate] = useState(false);
  const [hide,setHide]=useState(false)

  const [url, setUrl] = useState('');
  const [alyseiReview, setAlyseiReview] = useState();
  const [userType, setuserType] = useState();
  const [featureProductStatus, setFeatureProductStatus] = useState('');
  const [featuredProductId, setfeaturedProductId] = useState();
  const [deleteFeaturedProduct, setDeleteFeaturedProduct] = useState(false);
  const [updateFieldValue, setUpdateFieldValue] = useState({});
  const [pickupDeleveryArr, setpickupDeleveryArr] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [isCropped, setIsCropped] = useState(false);
  const [targetImageId, setTargetImageId] = useState('');
  const [openModal, setOpenModal] = useState('');
  const [image, setImage] = useState('');
  const [cropData, setCropData] = useState('');
  const [fileName, setFileName] = useState('');
  //const [cropper, setCropper] = useState();
  const [userPostPhotos, setUserPostPhotos] = useState([]);

  const [isOpenImage, setIsOpenImage] = useState(false);
  const [userPhotosData, setUserPhotosData] = useState([]);
  const [featuredProductButton, setFeaturedProductButton] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const profilePhotoFile = useRef(null);
  const profileCoverFile = useRef(null);
  const cropper = React.createRef(null);
  const [coverImage, setCoverImage] = useState('');
  const [coverLoader, setCoverLoader] = useState(false);
  const [coverImageHeight, setCoverImageHeight] = useState(460);
  const [coverImageWidth, setCoverImageWidth] = useState(1236);
  const [coverUploadSuccess, setCoverUploadSuccess] = useState(false);
  const [profileUploadSuccess, setProfileUploadSuccess] = useState(false);
  const [coverPhotoSizeError, setCoverPhotoSizeError] = useState(false);
  const [featuredProductImageUrl, setFeaturedProductImageUrl] = useState('');
  const [profilePhotoImage, setProfilePhotoImage] = useState('');
  const [productTypeArray, setProductTypeArray] = useState([]);
  const {
    profileData,
    profileProgressData: { data, data_progress },
    formField,
    formValue,
    errMessage,
    avatarSpinner,
    coverSpinner,
    updateProfileSpinner,
    errImageMessage,
    featuredProductSpinner,
    editFeatureProductData,
    updateUserFieldSpinner,
    countries,
    regions,
    cities,
    profiletabIndex,
  } = useSelector((state) => state.memberProfileData);
  let { featureProduct } = useSelector((state) => state.memberProfileData);
  const { getUserPost } = useSelector((state) => state.postState);
  const dispatch = useDispatch();
  const history = useHistory();
  const myRef = useRef(null);
  const divHeightWidth = useRef('cover__pic');
  useEffect(async () => {
    //console.log({height: divHeightWidth.current.clientHeight,width:divHeightWidth.current.clientWidth},"sdfgdsf");
    await setCoverImageHeight(divHeightWidth.current.clientHeight);
    await setCoverImageWidth(divHeightWidth.current.clientWidth);
  }, [coverImageHeight, coverImageWidth]);

  useEffect(async() => {
    editFeatureProductData?.fields?.map(async(item) => {
      if (item.name === 'listing_url') {
        if(item?.value !='' && item?.value != null && item?.value != 'null'){
          await setUrl(item?.value);
        }
      }
    });
  },[editFeatureProductData]);

  useEffect(async () => {
    const str = window.location.href;
    const getUrl = str.split('/');
    const bodyUrl = getUrl[getUrl.length - 1];
    document.body.classList.add(bodyUrl);
    document.body.classList.remove('addScroll');
    document.body.classList.remove("hidePageScroll");
    const userType = await auth.getUserType();
    await setuserType(JSON.parse(userType));
  }, []);

  useEffect(async () => {
    const root = document.querySelector('.tabs'),
      tabs = root.querySelectorAll('.tab'),
      btns = root.querySelectorAll('.btn');
    root.onclick = function (e) {
      var t = e.target,
        val = t.getAttribute('tab');
      if (val != null) {
        tabs.forEach((each) => {
          each.classList.remove('active-tab');
        });
        btns.forEach((each) => {
          each.classList.remove('active-button');
        });
        tabs[val - 1].classList.add('active-tab');
        btns[val - 1].classList.add('active-button');
      }
    };
    const queryStr =
      props && props.location && props.location.search.split('-');
    const id = queryStr[queryStr.length - 1];

    if (id) {
      await dispatch(visitorProfileData(id));
      await dispatch(profileProgress());
    } else {
      //await dispatch(memberProfileData());
      await dispatch(profileProgress());
      await dispatch(profileFormField());
    }
  }, []);


  useEffect(async () => {
    let userPhotos = [];
    await getUserPost?.data?.map((items) => {
      items?.attachments?.map((item) => {
        userPhotos.push({
          url: `${item?.attachment_link?.base_url}${
            item && item?.attachment_link?.attachment_url
          }`,
          type: 'photo',
          altTag: 'image',
        });
      });
    });
    await setUserPostPhotos(userPhotos);
  }, [getUserPost]);

  useEffect(async () => {
    await getUserNode();
  }, [
    profileData?.data?.user_data?.user_id,
    alyseiReview,
    localStorage.getItem('alysei_review'),
  ]);

  useEffect(async() => {
    formField?.data?.step_1?.map(async(field) => {
      if (field.type == 'checkbox') {
        field.options &&
          field.options.map((item) => {
            let opt = [];
            item.options.map((i) => {
              i.options.map((o) => {
                opt.push(o.user_field_option_id);
              });
            });
            let allCheckbox = {
              id: item.user_field_option_id,
              subopt: opt
            }
            productTypeArray.push(allCheckbox);
          });
      }
    });
    await setProductTypeArray(productTypeArray);
  },[formField]);

  useEffect(async() => {
    formField?.data?.step_1?.map(async(field) => {
      if (field.type == 'checkbox') {
        field.options &&
          field.options.map((item) => {
            if (item.is_selected)
            if(!productTypeList.includes(item.user_field_option_id)){
              productTypeList.push(item.user_field_option_id);
            //console.log(productTypeList,"productTypeList");
            formValue[item.user_field_id] = productTypeList;
            }
            item.options.map((i) => {
              i.options.map((o) => {
                if (o.is_selected){
                  if(!productTypeList.includes(o.user_field_option_id)){
                    productTypeList.push(o.user_field_option_id);
                    //console.log(productTypeList,"productTypeListproductTypeList");
                    formValue[o.user_field_id] = productTypeList;
                  }
                }
              });
            });
          });
      }
    });
    //console.log(formValue,"formValue78");
    await dispatch(setFieldValues(formValue));
  },[formField])

  // hanlde Edit pop-up start.
  useEffect(() => {
    const closeEditPopUp = (event) => {
      if (EditRef.current && !EditRef.current.contains(event.target)) {
        setchangeProfile(false);
      }
    };
    document.body.addEventListener('click', closeEditPopUp);
    return () => document.body.addEventListener('click', closeEditPopUp);
  }, [EditRef]);

  // hanlde pop-up end.

  const getUserNode = () => {
    const userId = profileData?.data?.user_data?.user_id;
    const fetchUserNode = firebase.database().ref('users').child(userId);
    fetchUserNode.on('value', (snapshot) => {
      const response = snapshot.val();
      setAlyseiReview(response?.alysei_approval);
    });
  };

  // for profile edit....
  const handleEditProfile = async () => {
    await setEditModel(true);
  };

  // get uploaded image dimension
  async function imageSize(url) {
    const img = document.createElement('img');

    const promise = new Promise((resolve, reject) => {
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        // Resolve promise with the width and height
        resolve({ width, height });
      };

      // Reject promise on error
      img.onerror = reject;
    });

    img.src = url;

    return promise;
  }

  const changeAvatar = async (event) => {
    let type = event.target.files[0];
    if (!type.name.match(/\.(jpg|jpeg|png|JPEG)$/)) {
      dispatch(setUploadImageErrors(lang?.imageType, event.target.id));
    } else if (event.target.files[0].size > 6200000) {
      dispatch(
        setUploadImageErrors(lang?.selectImageSizeLessThan10, event.target.id)
      );
    } else {
      let uploadImage = {};
      if (event.target.id === 'avatar_id') {
        await setOpenModal(true);
        await setTargetImageId(event.target.id);
        setFileName(event.target.files[0].name);
        setImage(URL.createObjectURL(event.target.files[0]));
        uploadImage[event.target.id] = event.target.files[0];
      } else if (event.target.id === 'cover_id') {
        const imageDimensions = await imageSize(
          URL.createObjectURL(event.target.files[0])
        );
        //console.log(imageDimensions,"imageDimensions");
        if (imageDimensions?.width < 1199) {
          await setCoverPhotoSizeError(true);
        } else {
          setTargetImageId(event.target.id);
          setFileName(event.target.files[0].name);
          setCoverImage(URL.createObjectURL(event.target.files[0]));
          uploadImage[event.target.id] = event.target.files[0];
        }
      }
    }
    setTimeout(() => {
      dispatch(setUploadImageErrors({ msg: '', field: '' }));
    }, 3000);
    return (event.target.value = null);
  };

  // Start Cropping your Image
  const getCropData = async () => {
    let uploadImage = {};
    await setIsCropped(true);
    await setCoverLoader(true);
    if (typeof cropper !== 'undefined') {
      setCropData(cropper.current.cropper.getCroppedCanvas().toDataURL());
      //console.log(cropper.current.cropper.getCroppedCanvas().toDataURL(),"dfjkhdsahfdsjk");
      if (parseInt(targetImageId) === 1) {
        await setImageUrl(
          cropper.current.cropper.getCroppedCanvas().toDataURL()
        );
        await setCropData('');
        await setImage('');
        await setTargetImageId('');
        await setFileName('');
        await setOpenModal(false);
        await dispatch(memberProfileData());
        await dispatch(profileProgress());
        await setIsCropped(false);
      }
      await fetch(cropper.current.cropper.getCroppedCanvas().toDataURL()).then(
        (res) =>
          res.blob().then(async (blob) => {
            const file = await new File([blob], `${fileName}`, {
              type: 'image/png',
            });
            if (parseInt(targetImageId) === 1) {
              featureProduct[targetImageId] = file;
            } else {
              uploadImage[targetImageId] = file;
            }
          })
      );
      // parseInt(targetImageId) === 1 &&
      //   (await dispatch(addFeatureProductList(featureProduct)));
      if (
        Object.keys(uploadImage)?.length > 0 &&
        parseInt(targetImageId) !== 1
      ) {
        await dispatch(changeAvatarCover(uploadImage)).then(async (res) => {
          if (res?.success === 200) {
            // if (targetImageId === 'avatar_id') {
            //   window.location.reload();
            // }
            await setCropData('');
            await setImage('');
            await setCoverImage('');
            await setTargetImageId('');
            await setCropData('');
            await setFileName('');
            await setOpenModal(false);
            await dispatch(memberProfileData());
            await dispatch(profileProgress());
            await setIsCropped(false);
            await setCoverLoader(false);
            if (targetImageId === 'avatar_id') {
              await setProfileUploadSuccess(true);
            } else {
              await setCoverUploadSuccess(true);
            }
            setTimeout(async () => {
              await setCoverUploadSuccess(false);
              await setProfileUploadSuccess(false);
            }, 4000);
          } else {
            await setIsCropped(false);
            await setCoverLoader(false);
            //console.log(res, '...error');
          }
        });
      }
    }
  };
  const closeModal = async () => {
    await setCropData('');
    await setFileName('');
    await setImage('');
    await setTargetImageId('');
    await setCropData('');
    await setOpenModal(false);
  };
  // End of Cropping

  const handleMultiSelect = async (id, selectedList) => {
    let arr = [];
    selectedList.map((item) => arr.push(item.user_field_option_id));
    formValue[id] = arr;
    // await dispatch(setFieldValues(formValue));
  };

  const handleChange = async (e) => {
    if (e.target.name === 'listing_url') {
      url.length === 0 ? setUrl(e.target.value) : setUrl(e.target.value);
      featureProduct[e.target.id] = url;
    }
    if (e.target.name === 'phone') {
      const regEx = /^[0-9\b]+$/;
      if (e.target.value === '' || regEx.test(e.target.value)) {
        setPhone(e.target.value);
      } else {
        setPhone(phone);
      }
    } else {
      setPhone(phone);
    }

    formValue[e.target.id] = e.target.value;
    await dispatch(setFieldValues(formValue));
    if (parseInt(e.target.id) === 1) {
      const errorArray = {};
      const fsize = e.target.files[0].size;
      const fSizeKB = Math.round((fsize / 1024));
      if (fSizeKB > 5001) {
        errorArray.image_req = lang?.selectImageSizeLessThan10;
        await dispatch(setFormErrors(errorArray, 'title'));
        setTimeout(() => {
          dispatch(setFormErrors({ msg: '', field: '' }));
        }, 3000);
        return (e.target.value = null);
      }
      //setOpenModal(true);
      setTargetImageId(e.target.id);
      setFileName(e.target.files[0].name);
      setFeaturedProductImageUrl(URL.createObjectURL(e.target.files[0]));
      return (e.target.value = null);
    } else {
      //console.log(e.target.id, 'e.target.id');
      featureProduct[e.target.id] = e.target.value;
      await dispatch(addFeatureProductList(featureProduct));
    }
  };

  const handleInput = async (e) => {
    if (parseInt(e.target.id) === 28) {
      await dispatch(getCity(e.target.value));
    } else if (parseInt(e.target.id) === 13) {
      await dispatch(getRegion(e.target.value));
    } else {
      formValue[e.target.id] = await e.target.value;

      // await dispatch(setFieldValues(formValue));
    }
    // parseInt(e.target.id) === 28 && await dispatch(getCity(e.target.value))
    // parseInt(e.target.id) === 13 && await dispatch(getRegion(e.target.value))
    // await setFieldInputValues(formValue)
  };

  const handleUserField = async (e) => {
    updateFieldValue['user_field_id'] = e.target.id;
    updateFieldValue['value'] = e.target.value;
    await setUpdateFieldValue(updateFieldValue);
  };


  // checked box for profile edit
  const handleCheckBox = async (e, isDefault) => {
    if (!isDefault) {
      
      if (e.target && e.target.checked) {
        if (parseInt(e.target.value) === 628) {
          await setPickup(e.target.checked);
          pickupDeleveryArr.push(e.target.value);
          formValue[e.target.id] = pickupDeleveryArr;
          await dispatch(setFieldValues(formValue));
        } else if (parseInt(e.target.value) === 629) {
          await setDelevery(e.target.checked);
          pickupDeleveryArr.push(e.target.value);
          formValue[e.target.id] = pickupDeleveryArr;
          await dispatch(setFieldValues(formValue));
        } else if (e.target.name == 0) {
          await SetConservationMethod(false);
          await SetProperty(false);
        } else if (e.target.name === 'conservation_method') {
          SetConservationMethod(true);
        } else if (e.target.name === 'properties') {
          SetProperty(true);
        }
        //console.log(e.target.name,"input name");
        productTypeList.push(parseInt(e.target.value));
        let uniqueArr = [...new Set(productTypeList)];
        await setProductTypeList(uniqueArr);
        if(e.target.id === "1" && e.target.value === "1"){
          formValue[2] = uniqueArr;
        }else{
          formValue[e.target.id] = uniqueArr;
        }
        await dispatch(setFieldValues(formValue));
      } else {
        if (parseInt(e.target && e.target.value) === 628) {
          formValue[21] = 716;
          await setPickup(e.target.checked);
          const index = pickupDeleveryArr.indexOf(e.target.value);
          if (index > -1) pickupDeleveryArr.splice(index, 1);
          await setpickupDeleveryArr(pickupDeleveryArr);
          formValue[e.target.id] = pickupDeleveryArr;
          await dispatch(setFieldValues(formValue));
        } else if (parseInt(e.target && e.target.value) === 629) {
          formValue[22] = 717;
          await setDelevery(e.target.checked);
          const index = pickupDeleveryArr.indexOf(e.target.value);
          if (index > -1) pickupDeleveryArr.splice(index, 1);
          await setpickupDeleveryArr(pickupDeleveryArr);
          formValue[e.target.id] = pickupDeleveryArr;
          await dispatch(setFieldValues(formValue));
        }
         // for product selection expression start.
        let uncheckOptionsData = await formField?.data?.step_1?.filter((element)=> element.title ==="Product type")
        if(uncheckOptionsData?.length>0){
         let newData =  uncheckOptionsData?.map((item) => item.options?.map((option) => option?.user_field_option_id == e.target.value ?{...option} :option))
         let updatedValue = newData.flat()?.map((opt) => opt?.user_field_option_id==e.target.value ? {...opt,is_selected :false,options :opt.options.map((childOpt)=>childOpt?.parent==e.target.value ?{...childOpt,is_selected :false,options :childOpt?.options?.map(d => childOpt?.parent==e.target.value ?{...d,is_selected :false}:d)}:childOpt)}:opt);
         if(updatedValue?.length>0){
           let newFormFieldsValue = {
           ...formField,
           data :{...formField.data,step_1 :formField.data?.step_1?.map(fieldOption => fieldOption?.name ==="product_type" ?{...fieldOption,options :updatedValue}:fieldOption)}
         }
         await dispatch(getUserProfileFormField(newFormFieldsValue));
        }}
        // for product selection expression end.
        let uniqueArr = [...new Set(productTypeList)];
        const index = uniqueArr.indexOf(parseInt(e.target && e.target.value));
        if (index > -1) uniqueArr.splice(index, 1);
        let found = productTypeArray.some(el => el.id === parseInt(e.target.value));
        if(found){
          let resultObject = productTypeArray.find(o => o.id === parseInt(e.target.value));
          const iterator = resultObject.subopt.values();
          for (const value of iterator) {
            const index = uniqueArr.indexOf(parseInt(value));
            if (index > -1) uniqueArr.splice(index, 1);
          }
        }
        await setProductTypeList(uniqueArr);
        //console.log(resultObject.subopt, 'resultObject');
        if(e.target.id === "1" && e.target.value === "1"){
          formValue[2] = uniqueArr;
        }else{
          formValue[e.target.id] = uniqueArr;
        }
        await dispatch(setFieldValues(formValue));
      }
    } else {
      if (parseInt(e.user_field_option_id) === 628 && e.is_selected) {
        setPickup(e.is_selected);
        pickupDeleveryArr.push(e.target?.value);
        formValue[e.target?.id] = pickupDeleveryArr;
        await dispatch(setFieldValues(formValue));
      } else if (parseInt(e.user_field_option_id) === 629 && e.is_selected) {
        setDelevery(e.is_selected);
        pickupDeleveryArr.push(e.target?.value);
        formValue[e.target?.id] = pickupDeleveryArr;
        await dispatch(setFieldValues(formValue));
      }
    }
  };
  const scrollToRef = (ref) => { window.scroll(0, ref.current && ref.current.offsetTop - 200); };

  const addFeaturedList = async (featureProductField) => {
    if (parseInt(targetImageId) === 1) {
      if (featuredProductImageUrl != '') {
        await fetch(
          cropper.current.cropper.getCroppedCanvas().toDataURL()
        ).then((res) =>
          res.blob().then(async (blob) => {
            const file = await new File([blob], `${fileName}`, {
              type: 'image/png',
            });
            featureProduct[targetImageId] = file;
          })
        );
      }
    }

    //console.log(featureProduct,"featureProduct");

    let imagefield = '';
    let titlefield = '';
    let urlfield = '';
    let descriptionfield = '';
    await profileData?.data?.products[0].fields?.map((item) => {
      if (item.type === 'file') {
        imagefield = item.featured_listing_field_id;
      } else if (item.type === 'url') {
        urlfield = item.featured_listing_field_id;
      } else if (item.type === 'text' && item.required === 'yes') {
        titlefield = item.featured_listing_field_id;
      } else if (item.type === 'text') {
        descriptionfield = item.featured_listing_field_id;
      }
    });
    if (
      ((featureProduct[urlfield] !== undefined &&
        featureProduct[urlfield] !== '') ||
        (featureProduct[descriptionfield] !== undefined &&
          featureProduct[descriptionfield] !== '')) &&
      featureProduct[titlefield] !== undefined &&
      featureProduct[titlefield] !== ''
    ) {
      if (featuredProductImageUrl === '') {
        delete featureProduct[imagefield];
      }

      setFeaturedProductButton(true);
      await dispatch(featureProductList(featureProduct)).then(
        async (response) => {
          if (response && response.success === 200) {
            await dispatch(setClearFeatureProductValue({}));
            await setImageUrl('');
            await setUrl('');
            await setOpenModel(false);
            await setfeatureProductTabModel(false);
            await setFeatureProductUpdate(false);
            await setTabModel(false);
            await dispatch(memberProfileData());
            await dispatch(profileProgress());
            await setFeaturedProductImageUrl('');
            setFeaturedProductButton(false);
          } else {
            await setFeatureProductStatus(response?.errors);
            await setImageUrl('');
            setFeaturedProductButton(false);
          }
        }
      );
    } else {
      const errorArray = {};
      if (
        featureProduct[imagefield] == undefined ||
        featureProduct[imagefield] == ''
      ) {
        errorArray.image_req = lang?.image_field_required;
      }

      if (
        featureProduct[titlefield] == undefined ||
        featureProduct[titlefield] == ''
      ) {
        errorArray.title_req = lang?.Please_fill_title;
      }
      if (
        (featureProduct[urlfield] == undefined &&
          featureProduct[descriptionfield] == undefined) ||
        (featureProduct[urlfield] == '' &&
          featureProduct[descriptionfield] == '') ||
        (featureProduct[urlfield] == undefined &&
          featureProduct[descriptionfield] == '') ||
        (featureProduct[urlfield] == '' &&
          featureProduct[descriptionfield] == undefined)
      ) {
        errorArray.url_and_description =
          lang?.Please_fill_Url_or_Description_field;
      }
      await dispatch(setFormErrors(errorArray, 'title'));
      // (featureProduct[titlefield] !== undefined && featureProduct[titlefield] !== '') ? await dispatch(setFormErrors(lang?.Please_fill_Url_or_Description_field, "title"))
      //   : await dispatch(setFormErrors(lang?.Please_fill_title, "title"))
      scrollToRef(featureProductRef);
    }
    // setFeatureProductStatus(lang?.Please_fill_Url_or_Description_field)
    setTimeout(() => {
      dispatch(setFormErrors('', ''));
    }, 4000);
  };

  const deleteFeatureList = async (_id) => {
    await dispatch(deleteFeatureProductList(_id)).then(async (res) => {
      if (res && res.success === 200) {
        setDeleteFeaturedProduct(false);
        await dispatch(memberProfileData());
        // await dispatch(profileProgress(token));
      }
    });
  };

  
  function checkProductTypeChecked() {
    var checked = true;
    $( ".productTypeCheckbox" ).each(function() {
      if (this.checked) {
        var pId = $(this).val();
        var conversition = $('.conservation_method-'+pId+':checkbox:checked').length;
        var property = $('.properties-'+pId+':checkbox:checked').length;
        if(conversition === 0){
          dispatch(setFormErrors(lang?.Please_select_at_least_one_conservation_method, "product_type"));
          var elem = document.getElementById("product__type");
          elem.scrollIntoView();
          checked = false;
        }else if(property === 0){
          dispatch(setFormErrors(lang?.Please_select_at_least_one_Properties, "product_type"));
          var elem = document.getElementById("product__type");
          elem.scrollIntoView();
          checked = false;
        }
        
      }
    });

    return checked;
  }
  // submit edit profile data
  const editProfile = async () => {
    //console.log(formValue,"formValueformValue11");
    if (textAreaValues.length > 301) {
      await dispatch(
        setFormErrors(lang?.enterMaxCharacter, parseInt(textAreaId))
      );
    } else {
      if (textAreaValues.length > 0) {
        formValue[textAreaId] = textAreaValues;
      }
      formValue[2] = await [...new Set(formValue[2])];
      formValue[9] = await [...new Set(formValue[9])];
      //console.log(formValue,"formValue");
      delete formValue[1];
      let allChecked = checkProductTypeChecked();
      //console.log(allChecked,"allChecked");
      if(allChecked){
        //console.log("ready to update");
        await dispatch(updateProfile(formValue)).then(async (res) => {
          if (res) {
            await setEditModel(false);
            await setEditModelAbout(false);
            await dispatch(profileFormField());
            await dispatch(profileProgress());
            // await dispatch(memberProfileData());
            await dispatch(setFieldValues(formValue));
          }
        });
      }
    }
    setTimeout(() => {
      dispatch(setFormErrors({ msg: '', field: '' }));
    }, 4000);
  };

  const updateUserField = async () => {
    if (textAreaValues.length > 301) {
      await dispatch(
        setFormErrors(lang?.enterMaxCharacter, parseInt(textAreaId))
      );
    } else {
      if (textAreaValues.length > 0) {
        formValue[textAreaId] = textAreaValues;
      }
      await dispatch(userFieldUpdate(updateFieldValue)).then(async (res) => {
        if (res) {
          await setEditModelAbout(false);
          await dispatch(profileFormField());
          await dispatch(profileProgress());
          await dispatch(memberProfileData());
        }
      });
    }
    setTimeout(() => {
      dispatch(setFormErrors({ msg: '', field: '' }));
    }, 3000);
  };

  const handleProfileTab = async (item) => {
    if (item.redirect_to === 'edit_profile') {
      await setTabTitle(item.title);
      // setAboutTabModel(true)
      await setTextAreaState(false);
      await setEditModelAbout(true);
      await setTextAreaValues('');
      await setcontactModel(false);
      await setCoverTabModel(false);
      await setAvatarTabModel(false);
      await setHubSelectionTabModel(false);
      await setfeatureProductTabModel(false);
    } else if (item.redirect_to === 'edit_profile_image') {
      await setEditModel(false);
      await setcontactModel(false);
      await setCoverTabModel(false);
      await setAvatarTabModel(true);
      await setHubSelectionTabModel(false);
      setfeatureProductTabModel(false);
      profilePhotoFile.current.click();
    } else if (item.redirect_to === 'edit_cover_image') {
      setEditModel(false);
      setcontactModel(false);
      setCoverTabModel(true);
      setAvatarTabModel(false);
      setHubSelectionTabModel(false);
      setfeatureProductTabModel(false);
      profileCoverFile.current.click();
    } else if (item.redirect_to === 'edit_contact') {
      setEditModel(false);
      setcontactModel(true);
      setCoverTabModel(false);
      setAvatarTabModel(false);
      setHubSelectionTabModel(false);
      setfeatureProductTabModel(false);
      setEditContactModel(!editContactModel);
    } else if (item.redirect_to === 'edit_listing') {
      setEditModel(false);
      setcontactModel(false);
      setCoverTabModel(false);
      setAvatarTabModel(false);
      //setHubSelectionTabModel(false);
      setOpenModel(true);
      setTabModel(true);
      setfeatureProductTabModel(true);
    } else if (item.redirect_to === 'edit_hub') {
      setEditModel(false);
      setcontactModel(false);
      setCoverTabModel(false);
      setAvatarTabModel(false);
      setHubSelectionTabModel(true);
      setfeatureProductTabModel(false);
      history.push('/hubs');
    }
  };
  const handleModel = async () => {
    await dispatch(setClearFeatureProductValue({}));
    await setIsUrlStatus(false);
    setOpenModel(false);
    setTabModel(false);
    setFeatureProductUpdate(false);
    setImageUrl('');
    setUrl('');
    setFeaturedProductImageUrl('');
  };

  const handleFeatureProductEdit = async (id) => {
    await dispatch(updateProfileFeatureProductData(id));
    await setOpenModel(true);
  };

  // photos gallery
  const handlePhotos = async (userData, image) => {
    let userPhotos = [];
    await userData?.data?.map((items) => {
      items?.attachments?.map((item) => {
        userPhotos.push({
          url: `${item?.attachment_link?.base_url}${
            item && item?.attachment_link?.attachment_url
          }`,
          type: 'photo',
          altTag: 'image',
        });
      });
    });
    userPhotosData?.map((item, index) => {
      if (item?.url === image) {
        setImageIndex(index);
      }
    });
    await setUserPhotosData(userPhotos);
    await setIsOpenImage(true);
  };

  const cancelCropCover = async () => {
    await setCoverImage('');
    await setCoverLoader(false);
  };

  //console.log(editFeatureProductData,"editFeatureProductData");
  //console.log(productTypeList,"productTypeList");
  return (
    <Fragment>
      {/* crop modal  */}
      {openModal && (
        <Modal
          className=""
          ariaHideApp={false}
          isOpen={openModal}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
            },
            content: {
              position: 'absolute',
              top: '0',
              left: '0%',
              right: '0%',
              bottom: '200px',
              border: '1px solid #ccc',
              background: '#fff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              borderRadius: '4px',
              padding: '0px',
              // outline: 'none',
            },
          }}
        >
          <div className="popup_header flex justify-between items-center">
            <h4 className="page__title">{lang?.Crop_image}</h4>
            <button className="close_btn--modal" onClick={() => closeModal()}>
              {' '}
              {lang?.close}
            </button>
          </div>
          <div className="card card--block modal_box">
            <div className="crop_img_block">
              <div className="storeProfileImage ">
                <Cropper
                  zoomTo={0}
                  style={{ width: '100%' }}
                  preview=".img-preview"
                  src={image}
                  viewMode={1}
                  dragMode={'move'}
                  cropBoxMovable={false}
                  responsive={true}
                  cropBoxResizable={false}
                  ref={cropper}
                  ready={() => {
                    cropper.current.cropper.setCropBoxData({
                      left: 130,
                      top: 70,
                      width: 170,
                      height: 170,
                    });
                  }}
                  center={true}
                  guides={false}
                />
              </div>
            </div>
            <div className="form__action form__item mt-4">
              <button onClick={() => getCropData()}>
                {' '}
                {isCropped ? <FormSpinner /> : `${lang?.Crop_image}`}{' '}
              </button>
            </div>
          </div>
          {/* {cropData !== '' && <img style={{ width: "100%" }} src={cropData} alt="cropped" />} */}
        </Modal>
      )}
      {/* crop modal end */}
      <div
        className={
          userType &&
          userType.role_id !== constant.rolesId.voyagers &&
          localStorage.getItem('alysei_review') != true &&
          (alyseiReview === 'false' || alyseiReview === false)
            ? 'isOpen'
            : null
        }
      >
        {userType &&
          userType.role_id !== constant.rolesId.voyagers &&
          localStorage.getItem('alysei_review') != true &&
          (alyseiReview === 'false' || alyseiReview === false) && (
            <div className="appNotiFication">
              <h2>{lang?.Latest_Notifications}</h2>
              <div className="alert alert-primary">
                {
                  lang?.welcome_to_Alysei_world_you_will_be_notified_for_membership_status_update
                }
              </div>
            </div>
          )}
        <div className="home__page profile__page">
          {/* Layout Content */}
          {/* Profile Cover pic as Banner */}
          <div
            className={
              coverTabModel
                ? 'profile__cover profile__option--selected'
                : 'profile__cover '
            }
          >
            {coverSpinner ? (
              <FormSpinner />
            ) : (
              <Fragment>
                {coverImage ? (
                  <div className="cover__pics">
                    <Cropper
                      zoomTo={0}
                      style={{ top: 0, left: 0 }}
                      preview=".img-preview"
                      src={coverImage}
                      viewMode={1}
                      dragMode={'move'}
                      cropBoxMovable={false}
                      responsive={true}
                      cropBoxResizable={false}
                      ref={cropper}
                      ready={() => {
                        cropper.current.cropper.setCropBoxData({
                          left: 0,
                          top: 0,
                          width: coverImageWidth,
                          height: coverImageHeight,
                        });
                      }}
                      center={true}
                      guides={false}
                    />
                  </div>
                ) : (
                  <div className="cover__pic" ref={divHeightWidth}>
                    {profileData?.data?.user_data?.cover_id ? (
                      <img
                        src={`${profileData?.data?.user_data?.cover_id?.base_url}${profileData?.data?.user_data?.cover_id?.attachment_url}`}
                      />
                    ) : (
                      <img src={CoverImage} alt="Profile Image" />
                    )}
                  </div>
                )}
                {coverUploadSuccess ? (
                  <SuccessMessage msg={lang.coverImageSuccessMessage} />
                ) : null}
                {profileUploadSuccess ? (
                  <SuccessMessage msg={lang.profileImageSuccessMessage} />
                ) : null}
                {errImageMessage.field === 'cover_id' ? (
                  <FormError msg={errImageMessage.msg} />
                ) : null}
                {coverImage ? (
                  <div className="cropImage">
                    <div className="saveCropImage">
                      <button
                        type="button"
                        className="cancelImage"
                        onClick={() => cancelCropCover()}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="uploadlImage"
                        onClick={() => getCropData()}
                      >
                        Save Image
                      </button>
                    </div>
                    {coverLoader ? (
                      <div className="coverPhotoOverlay">
                        <FormSpinner />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                ) : (
                  <form className="cover__upload">
                    <label>
                      <input
                        type="file"
                        name="cover"
                        id="cover_id"
                        accept="image/png,image/jpeg"
                        onChange={(e) => changeAvatar(e)}
                        ref={profileCoverFile}
                      />
                      {lang?.Change_Banner}
                    </label>
                  </form>
                )}
              </Fragment>
            )}
          </div>

          <div className="site-align top-align">
            {/* Left Block */}
            <div className="left__section-block profile__left-section md:mb-1 sm:mb-2">
              <div className="card card--block">
                <div className="user_profile-detail p--6">
                  <div
                    className={
                      avatarTabModel
                        ? 'user__pic profile__option--selected'
                        : 'user__pic myProfile'
                    }
                    style={{
                      border: `${'0.313rem solid'}#${
                        profileData?.data?.user_data?.profile_color
                      }`,
                    }}
                  >
                    {avatarSpinner ? (
                      <FormSpinner />
                    ) : (
                      <Fragment>
                        <form className="profile__upload">
                          <label>
                            <input
                              type="file"
                              name="avatar"
                              id="avatar_id"
                              accept="image/*"
                              onChange={(e) => {
                                changeAvatar(e);
                                setchangeProfile(false);
                              }}
                              ref={profilePhotoFile}
                            />{' '}
                            {lang?.Change_Profile_Photo}
                          </label>
                        </form>
                        {profileData?.data?.user_data ? (
                          profileData?.data?.user_data?.avatar_id ? (
                            profilePhotoImage != '' ? (
                              <img
                                src={profilePhotoImage}
                                alt="Profile Image"
                              />
                            ) : (
                              <img
                                src={`${profileData.data?.user_data?.avatar_id.base_url}${profileData.data?.user_data?.avatar_id?.attachment_large_url}`}
                                alt="Profile Image"
                              />
                            )
                          ) : (
                            <img src={userProfile} alt="Profile Image" />
                          )
                        ) : (
                          <FormSpinner />
                        )}
                        {/* <ContentLoader viewBox="0 2 238 70" speed={2} width="162" height="162" backgroundColor="#bababa" foregroundColor="#a29a9a">
                        <circle cx="20" cy="20" r="20" />
                        </ContentLoader> */}

                        {errImageMessage.field === 'avatar_id' ? (
                          <FormError msg={errImageMessage.msg} />
                        ) : null}
                      </Fragment>
                    )}
                  </div>
                  <div className="user__name text-center mt-3 mb-3">
                    {profileData.data?.user_data ? (
                      <span className="user_cate">
                        {profileData.data?.user_data?.restaurant_name ??
                          profileData.data?.user_data?.company_name ??
                          `${profileData?.data?.user_data?.first_name} ${profileData?.data?.user_data?.last_name}` ??
                          profileData?.data?.user_data?.username}
                      </span>
                    ) : (
                      <div className="user_cate">
                        <ContentLoader
                          viewBox="0 0 299 70"
                          speed={2}
                          width={100}
                          height={20}
                          backgroundColor="#bababa"
                          foregroundColor="#a29a9a"
                        >
                          <rect
                            x="0"
                            y="0"
                            rx="0"
                            ry="0"
                            width="100%"
                            height="100%"
                          />
                        </ContentLoader>
                      </div>
                    )}
                    {/* <span>
                    <a href="javascript:void(0)">
                      {profileData && profileData.data
                        ? profileData.data.user_data.username
                        : ""}
                    </a>
                  </span> */}
                  </div>
                  <div className="profile__bg__white left-block text-center">
                    <div className="flex mt-3 mb-3 profile__Post">
                      <div className="w-1/3">
                        <div className="outer__div">
                          <h6>
                            {lang?.Posts}{' '}
                            <span className="flex">
                              {profileData?.data ? (
                                profileData?.data?.post_count
                              ) : (
                                <ContentLoader
                                  viewBox="0 0 300 250"
                                  speed={2}
                                  width={20}
                                  height={25}
                                  backgroundColor="#bababa"
                                  foregroundColor="#a29a9a"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    rx="0"
                                    ry="0"
                                    width="100%"
                                    height="100%"
                                  />
                                </ContentLoader>
                              )}
                            </span>
                          </h6>
                        </div>
                      </div>
                      <div className="w-1/3">
                        <div className="outer__div">
                          <h6>
                            {lang?.Connections}{' '}
                            <span className="flex">
                              {profileData?.data ? (
                                profileData?.data?.connection_count
                              ) : (
                                <ContentLoader
                                  viewBox="0 0 300 250"
                                  speed={2}
                                  width={20}
                                  height={25}
                                  backgroundColor="#bababa"
                                  foregroundColor="#a29a9a"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    rx="0"
                                    ry="0"
                                    width="100%"
                                    height="100%"
                                  />
                                </ContentLoader>
                              )}
                            </span>
                          </h6>
                        </div>
                      </div>
                      <div className="w-1/3">
                        {userType?.role_id !== constant.rolesId.voyagers && (
                          <div className="outer__div">
                            <h6>
                              {lang?.Followers}{' '}
                              <span className="flex">
                                {profileData?.data ? (
                                  profileData?.data?.follower_count
                                ) : (
                                  <ContentLoader
                                    viewBox="0 0 300 250"
                                    speed={2}
                                    width={20}
                                    height={25}
                                    backgroundColor="#bababa"
                                    foregroundColor="#a29a9a"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      rx="0"
                                      ry="0"
                                      width="100%"
                                      height="100%"
                                    />
                                  </ContentLoader>
                                )}
                              </span>
                            </h6>
                          </div>
                        )}
                        {userType?.role_id === constant.rolesId.voyagers && (
                          <div className="outer__div">
                            <h6>
                              {lang?.Following}{' '}
                              <span className="flex">
                                {profileData?.data ? (
                                  profileData?.data?.following_count
                                ) : (
                                  <ContentLoader
                                    viewBox="0 0 300 250"
                                    speed={2}
                                    width={20}
                                    height={25}
                                    backgroundColor="#bababa"
                                    foregroundColor="#a29a9a"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      rx="0"
                                      ry="0"
                                      width="100%"
                                      height="100%"
                                    />
                                  </ContentLoader>
                                )}
                              </span>
                            </h6>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-block-mobile">
                <div className="card card--block">
                  {/* {
                          profileData &&
                          profileData.data &&
                          profileData.data.user_data&&profileData.data.user_data.available_to_connect 
                        } */}
                  <div className="flex flex-wrap items-center justify-between rightBlockBtn">
                    <div className="editProfileBtn">
                      <div className="edit__profile editBtn">
                        <span
                          className="edit__profile-btn"
                          onClick={() => handleEditProfile()}
                        >
                          {' '}
                          {lang?.Edit}{' '}
                        </span>
                        <span
                          className="edit__pics"
                          onClick={() => setchangeProfile(!changeProfile)}
                        >
                          <i className="fas fa-caret-down" />{' '}
                        </span>
                        {changeProfile ? (
                          <div className="edit__options">
                            <form className="profile__upload">
                              <label>
                                <input
                                  type="file"
                                  name="avatar"
                                  id="avatar_id"
                                  onChange={(e) => {
                                    changeAvatar(e);
                                    setchangeProfile(false);
                                  }}
                                />{' '}
                                {lang?.Change_Profile_Photo}
                              </label>
                              <label>
                                <input
                                  type="file"
                                  name="cover"
                                  id="cover_id"
                                  accept="image/png,image/jpeg"
                                  onChange={(e) => {
                                    changeAvatar(e);
                                    setchangeProfile(false);
                                  }}
                                />{' '}
                                {lang?.Change_Banner}
                              </label>
                            </form>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="editProfileBtn">
                      <Link to="/setting" className="btn btnPrimary Icon">
                        <span>
                          <svg
                            width="20"
                            height="19"
                            viewBox="0 0 24 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22.634 9.37872L20.2883 8.77544C20.1691 8.44402 20.0282 8.12012 19.8665 7.80567L20.9847 5.89328C21.1874 5.55607 21.2684 5.16421 21.2152 4.7784C21.162 4.39259 20.9775 4.03435 20.6904 3.75918L20.0805 3.17475C19.7934 2.89956 19.4196 2.72278 19.017 2.6718C18.6144 2.62081 18.2055 2.69846 17.8536 2.89272L15.8581 3.9643C15.53 3.80932 15.192 3.67432 14.8462 3.5601L14.2167 1.31213C14.1116 0.935675 13.8798 0.602986 13.5573 0.365722C13.2347 0.128459 12.8394 -0.000102857 12.4328 6.17454e-08H11.5672C11.1613 5.09783e-05 10.7667 0.128331 10.4445 0.364985C10.1223 0.601638 9.89047 0.933469 9.78492 1.30911L9.15541 3.55708C8.80954 3.67123 8.47156 3.80623 8.14348 3.96128L6.14715 2.89046C5.79527 2.6962 5.38638 2.61855 4.98379 2.66953C4.58121 2.72052 4.2074 2.8973 3.92026 3.17249L3.31043 3.75692C3.02315 4.03202 2.8386 4.39027 2.7854 4.77611C2.73219 5.16195 2.81329 5.55384 3.01613 5.89102L4.13429 7.80341C3.97259 8.11785 3.83172 8.44175 3.71252 8.77318L1.36603 9.37646C0.973924 9.47765 0.62757 9.69991 0.380614 10.0088C0.133658 10.3178 -0.000119861 10.6961 8.05815e-08 11.0852V11.9148C5.32109e-05 12.3038 0.133911 12.6819 0.380853 12.9907C0.627796 13.2995 0.974054 13.5216 1.36603 13.6228L3.71174 14.2261C3.83085 14.5575 3.97172 14.8814 4.13351 15.1958L3.01613 17.109C2.81342 17.4462 2.7324 17.8381 2.7856 18.2239C2.8388 18.6097 3.02327 18.9679 3.31043 19.2431L3.92026 19.8275C4.20733 20.1028 4.58115 20.2797 4.98377 20.3307C5.38638 20.3817 5.79531 20.3039 6.14715 20.1095L8.14269 19.038C8.4708 19.1929 8.80879 19.3279 9.15462 19.4422L9.78413 21.6901C9.88957 22.066 10.1214 22.3981 10.4438 22.6349C10.7662 22.8718 11.161 23.0001 11.5672 23H12.4328C12.8387 22.9999 13.2333 22.8717 13.5555 22.635C13.8777 22.3984 14.1095 22.0665 14.2151 21.6909L14.8446 19.4429C15.1905 19.3288 15.5284 19.1938 15.8565 19.0387L17.8521 20.1103C18.2039 20.3046 18.6128 20.3822 19.0154 20.3312C19.418 20.2802 19.7918 20.1035 20.079 19.8283L20.6888 19.2438C20.9759 18.9687 21.1604 18.6104 21.2136 18.2246C21.2668 17.8388 21.1858 17.4469 20.9831 17.1097L19.8649 15.1973C20.0266 14.8829 20.1675 14.559 20.2867 14.2276L22.6324 13.6243C23.0249 13.5234 23.3717 13.3011 23.619 12.992C23.8663 12.6829 24.0002 12.3042 24 11.9148V11.0852C23.9997 10.6964 23.8658 10.3186 23.6188 10.0101C23.3719 9.70159 23.0258 9.47969 22.634 9.37872Z"
                              fill="url(#paint0_linear_526_8319)"
                            />
                            <path
                              d="M11.9998 7.07715C11.0871 7.07715 10.1948 7.33654 9.43585 7.82252C8.6769 8.3085 8.08538 8.99925 7.73607 9.80741C7.38677 10.6156 7.29537 11.5048 7.47344 12.3628C7.65152 13.2207 8.09106 14.0088 8.73649 14.6273C9.38192 15.2459 10.2043 15.6671 11.0995 15.8377C11.9947 16.0084 12.9227 15.9208 13.766 15.5861C14.6093 15.2513 15.33 14.6844 15.8371 13.9571C16.3443 13.2298 16.6149 12.3747 16.6149 11.4999C16.6149 10.3269 16.1287 9.20199 15.2632 8.37255C14.3977 7.54312 13.2238 7.07715 11.9998 7.07715Z"
                              fill="url(#paint1_linear_526_8319)"
                            />
                            <path
                              d="M12.0003 9.73096C11.6352 9.73096 11.2783 9.83471 10.9747 10.0291C10.6712 10.2235 10.4345 10.4998 10.2948 10.8231C10.1551 11.1463 10.1185 11.502 10.1898 11.8452C10.261 12.1884 10.4368 12.5036 10.695 12.751C10.9532 12.9984 11.2821 13.1669 11.6402 13.2352C11.9983 13.3035 12.3695 13.2684 12.7068 13.1345C13.0441 13.0006 13.3324 12.7739 13.5352 12.4829C13.7381 12.192 13.8464 11.85 13.8464 11.5001C13.8464 11.0309 13.6519 10.5809 13.3057 10.2491C12.9595 9.91735 12.4899 9.73096 12.0003 9.73096Z"
                              fill="white"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_526_8319"
                                x1="0"
                                y1="0"
                                x2="23.6436"
                                y2="11.1516"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#8160FE" />
                                <stop offset="1" stopColor="#44DBDC" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_526_8319"
                                x1="7.38477"
                                y1="7.07715"
                                x2="16.5804"
                                y2="9.0922"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#05B3D3" />
                                <stop offset="1" stopColor="#C081D3" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </span>
                        {lang?.Settings}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card card--block mt-2">
                <div className="user_all_detail p-4">
                  {profileData?.data?.about_tab
                    ?.filter((item) => item.value !== '0%')
                    .map((item, index) => {
                      if (item.type === 'checkbox') {
                        // const val = item && item.value.split(',')
                        let val = [...new Set(item?.value.split(','))];
                        return (
                          <Fragment key={index}>
                            <div className="blockRow">
                              <h4 className="font-size-18 pb-2">
                                {item.title}
                              </h4>
                              <div className="selectedProduct">
                                <ul>
                                  {val?.map((v, i) => (
                                    <li>
                                      <Link to="#" key={i}>
                                        {v}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </Fragment>
                        );
                      }
                      if (item.type === 'multiselect') {
                        return (
                          <Fragment key={index}>
                            <div className="blockRow">
                              <h4 className="font-size-18 pb-2">
                                {item.title}
                              </h4>
                              <p className="">{item.value}</p>
                            </div>
                          </Fragment>
                        );
                      } else {
                        return (
                          // about listing at home
                          <Fragment key={index}>
                            <div className="blockRow">
                              <h4 className="font-size-18 pb-2">
                                {item.title}
                              </h4>
                              {item.type === 'text' ? (
                                <Fragment>
                                  <ReactReadMoreReadLess
                                    charLimit={100}
                                    readMoreText={'See more'}
                                    readLessText={'See less'}
                                    readMoreClassName="read-more-less--more"
                                    readLessClassName="read-more-less--less"
                                  >
                                    {item?.value}
                                  </ReactReadMoreReadLess>
                                </Fragment>
                              ) : (
                                <p className="">{item?.value}</p>
                              )}
                            </div>
                          </Fragment>
                        );
                      }
                    })}
                </div>
              </div>
              {/* Fearture Products */}
            </div>

            <div className="tabs middle__section-block md:order-2 sm:order-2 xl:order-1 xl:order-1 xl:mt-0 lg:mt-0 md:mt-2 sm:mt-2">
              <div className="tab__list">
                <Tabs
                  selectedIndex={profiletabIndex}
                  onSelect={(index) => dispatch(setProfileTabIndex(index))}
                >
                  <TabList className="TabUpperList">
                    <Tab
                      className="TabInnerList"
                      onClick={() => setContactInfo(false)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.72727 9.81818H7.27273C6.67018 9.81818 6.18182 9.32982 6.18182 8.72727V7.27273C6.18182 6.67018 6.67018 6.18182 7.27273 6.18182H8.72727C9.32982 6.18182 9.81818 6.67018 9.81818 7.27273V8.72727C9.81818 9.32982 9.32982 9.81818 8.72727 9.81818ZM3.63636 8.72727V7.27273C3.63636 6.67018 3.148 6.18182 2.54545 6.18182H1.09091C0.488364 6.18182 0 6.67018 0 7.27273V8.72727C0 9.32982 0.488364 9.81818 1.09091 9.81818H2.54545C3.148 9.81818 3.63636 9.32982 3.63636 8.72727ZM16 8.72727V7.27273C16 6.67018 15.5116 6.18182 14.9091 6.18182H13.4545C12.852 6.18182 12.3636 6.67018 12.3636 7.27273V8.72727C12.3636 9.32982 12.852 9.81818 13.4545 9.81818H14.9091C15.5116 9.81818 16 9.32982 16 8.72727ZM9.81818 14.9091V13.4545C9.81818 12.852 9.32982 12.3636 8.72727 12.3636H7.27273C6.67018 12.3636 6.18182 12.852 6.18182 13.4545V14.9091C6.18182 15.5116 6.67018 16 7.27273 16H8.72727C9.32982 16 9.81818 15.5116 9.81818 14.9091ZM3.63636 14.9091V13.4545C3.63636 12.852 3.148 12.3636 2.54545 12.3636H1.09091C0.488364 12.3636 0 12.852 0 13.4545V14.9091C0 15.5116 0.488364 16 1.09091 16H2.54545C3.148 16 3.63636 15.5116 3.63636 14.9091ZM16 14.9091V13.4545C16 12.852 15.5116 12.3636 14.9091 12.3636H13.4545C12.852 12.3636 12.3636 12.852 12.3636 13.4545V14.9091C12.3636 15.5116 12.852 16 13.4545 16H14.9091C15.5116 16 16 15.5116 16 14.9091ZM9.81818 2.54545V1.09091C9.81818 0.488364 9.32982 0 8.72727 0H7.27273C6.67018 0 6.18182 0.488364 6.18182 1.09091V2.54545C6.18182 3.148 6.67018 3.63636 7.27273 3.63636H8.72727C9.32982 3.63636 9.81818 3.148 9.81818 2.54545ZM3.63636 2.54545V1.09091C3.63636 0.488364 3.148 0 2.54545 0H1.09091C0.488364 0 0 0.488364 0 1.09091V2.54545C0 3.148 0.488364 3.63636 1.09091 3.63636H2.54545C3.148 3.63636 3.63636 3.148 3.63636 2.54545ZM16 2.54545V1.09091C16 0.488364 15.5116 0 14.9091 0H13.4545C12.852 0 12.3636 0.488364 12.3636 1.09091V2.54545C12.3636 3.148 12.852 3.63636 13.4545 3.63636H14.9091C15.5116 3.63636 16 3.148 16 2.54545Z"
                          fill="url(#paint0_linear_563_7873)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_563_7873"
                            x1="8"
                            y1="21.9618"
                            x2="8"
                            y2="-7.75891"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#15AEDE" />
                            <stop offset="0.158" stopColor="#195DE1" />
                            <stop offset="0.724" stopColor="#28A1EC" />
                            <stop offset="1" stopColor="#2EB5F0" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <span>{lang?.only_Post}</span>
                    </Tab>
                    <Tab
                      className="TabInnerList"
                      onClick={() => setContactInfo(false)}
                    >
                      <svg
                        width="21"
                        height="18"
                        viewBox="0 0 21 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.117 0H2.013C0.90585 0 0 0.947294 0 2.1051V15.7882C0 16.946 0.90585 17.8933 2.013 17.8933H18.117C19.2241 17.8933 20.13 16.946 20.13 15.7882V2.1051C20.13 0.947294 19.2241 0 18.117 0Z"
                          fill="#8CC5C2"
                        />
                        <path
                          d="M18.8716 1.91699H1.25781V15.976H18.8716V1.91699Z"
                          fill="url(#paint0_linear_563_7880)"
                        />
                        <path
                          d="M18.8727 15.9764H12.582L16.2872 10.5956C16.6269 10.1035 17.344 10.1035 17.6837 10.5956L18.8727 12.321V15.9764Z"
                          fill="url(#paint1_linear_563_7880)"
                        />
                        <path
                          d="M16.6073 15.9762H6.03906L10.6249 9.31729C10.9646 8.82523 11.6818 8.82523 12.0214 9.31729L16.6073 15.9762Z"
                          fill="url(#paint2_linear_563_7880)"
                        />
                        <path
                          d="M11.4486 15.9762H1.25781V10.3142L3.70487 6.76114C4.04456 6.26907 4.76169 6.26907 5.10138 6.76114L11.4486 15.9762Z"
                          fill="url(#paint3_linear_563_7880)"
                        />
                        <path
                          d="M15.7269 3.83447C15.3932 3.83447 15.0732 3.96913 14.8372 4.20882C14.6013 4.44851 14.4688 4.7736 14.4688 5.11257C14.4688 5.45154 14.6013 5.77663 14.8372 6.01632C15.0732 6.25601 15.3932 6.39066 15.7269 6.39066C16.0605 6.39066 16.3806 6.25601 16.6165 6.01632C16.8524 5.77663 16.985 5.45154 16.985 5.11257C16.985 4.7736 16.8524 4.44851 16.6165 4.20882C16.3806 3.96913 16.0605 3.83447 15.7269 3.83447Z"
                          fill="url(#paint4_linear_563_7880)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_563_7880"
                            x1="10.0647"
                            y1="2.23651"
                            x2="10.0647"
                            y2="14.5382"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#CBFFFC" />
                            <stop offset="1" stopColor="#5BEFE8" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_563_7880"
                            x1="12.582"
                            y1="13.1015"
                            x2="18.8727"
                            y2="13.1015"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#16A085" />
                            <stop offset="1" stopColor="#F4D03F" />
                          </linearGradient>
                          <linearGradient
                            id="paint2_linear_563_7880"
                            x1="6.03906"
                            y1="12.4622"
                            x2="16.6073"
                            y2="12.4622"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#16A085" />
                            <stop offset="1" stopColor="#F4D03F" />
                          </linearGradient>
                          <linearGradient
                            id="paint3_linear_563_7880"
                            x1="1.25781"
                            y1="11.1841"
                            x2="11.4486"
                            y2="11.1841"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#16A085" />
                            <stop offset="1" stopColor="#F4D03F" />
                          </linearGradient>
                          <linearGradient
                            id="paint4_linear_563_7880"
                            x1="14.4688"
                            y1="5.11257"
                            x2="16.985"
                            y2="5.11257"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FFD25F" />
                            <stop offset="1" stopColor="#FFB448" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <span>{lang?.Photos}</span>
                    </Tab>
                    <Tab
                      className="TabInnerList"
                      onClick={() => setContactInfo(false)}
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_544_8177)">
                          <path
                            d="M15.0997 5.63679C15.0997 8.3164 12.9561 10.4601 10.2764 10.4601C7.59682 10.4601 5.45312 8.3164 5.45312 5.63679C5.45312 2.95717 7.59682 0.813477 10.2764 0.813477C12.9561 0.813477 15.0997 2.95717 15.0997 5.63679Z"
                            fill="url(#paint0_linear_544_8177)"
                          />
                          <path
                            d="M20.1326 17.6976C20.1326 17.6976 17.3947 12.1377 10.2763 12.1377C3.15779 12.1377 0.419922 17.6976 0.419922 17.6976V20.9455H20.1326V17.6976Z"
                            fill="url(#paint1_linear_544_8177)"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_544_8177"
                            x1="5.45312"
                            y1="0.813477"
                            x2="15.0997"
                            y2="10.4601"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FEC163" />
                            <stop offset="1" stopColor="#DE4313" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_544_8177"
                            x1="0.419922"
                            y1="12.1377"
                            x2="6.98089"
                            y2="26.8218"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#6B73FF" />
                            <stop offset="1" stopColor="#000DFF" />
                          </linearGradient>
                          <clipPath id="clip0_544_8177">
                            <rect
                              width="20.1321"
                              height="20.1321"
                              fill="white"
                              transform="translate(0 0.8125)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>
                        {userType?.role_id == constant.rolesId.voyagers ||
                        userType?.role_id == constant.rolesId.voiceOfExpert
                          ? lang?.only_about
                          : lang?.About_us}
                      </span>
                    </Tab>
                    <Tab className="TabInnerList">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_544_8192)">
                          <path
                            d="M16.8204 20.9456H4.02539V0.813477H16.8204C17.9031 0.813477 18.7889 1.71942 18.7889 2.82668V18.9323C18.7889 20.0396 17.9031 20.9456 16.8204 20.9456Z"
                            fill="url(#paint0_linear_544_8192)"
                          />
                          <path
                            d="M3.13131 0.813477H4.02607V20.9456H3.13131C2.14708 20.9456 1.3418 20.0396 1.3418 18.9323V2.82668C1.3418 1.71942 2.14708 0.813477 3.13131 0.813477Z"
                            fill="url(#paint1_linear_544_8192)"
                          />
                          <path
                            d="M11.0717 6.85254C10.5124 6.85254 9.97593 7.06464 9.5804 7.44219C9.18487 7.81974 8.96267 8.33181 8.96267 8.86575C8.96267 9.39968 9.18487 9.91175 9.5804 10.2893C9.97593 10.6668 10.5124 10.879 11.0717 10.879C11.6311 10.879 12.1676 10.6668 12.5631 10.2893C12.9586 9.91175 13.1808 9.39968 13.1808 8.86575C13.1808 8.33181 12.9586 7.81974 12.5631 7.44219C12.1676 7.06464 11.6311 6.85254 11.0717 6.85254ZM14.7626 13.8988C14.7626 13.8988 13.7608 11.8856 11.0717 11.8856C8.38267 11.8856 7.38086 13.8988 7.38086 13.8988V14.9054H14.7626V13.8988Z"
                            fill="url(#paint2_linear_544_8192)"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_544_8192"
                            x1="4.02539"
                            y1="10.8795"
                            x2="18.7889"
                            y2="10.8795"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#F77062" />
                            <stop offset="1" stopColor="#FE5196" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_544_8192"
                            x1="4.02607"
                            y1="10.8795"
                            x2="1.3418"
                            y2="10.8795"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#D64638" />
                            <stop offset="1" stopColor="#E03177" />
                          </linearGradient>
                          <linearGradient
                            id="paint2_linear_544_8192"
                            x1="7.38086"
                            y1="10.879"
                            x2="14.7626"
                            y2="10.879"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" />
                          </linearGradient>
                          <clipPath id="clip0_544_8192">
                            <rect
                              width="20.1321"
                              height="20.1321"
                              fill="white"
                              transform="translate(0 0.8125)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>{lang?.Contact} </span>
                    </Tab>
                    {userType &&
                      userType.role_id !== constant.rolesId.voyagers &&
                      data?.profile_percentage === 100 && (
                        <Tab
                          className="TabInnerList"
                          onClick={() => setContactInfo(false)}
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.66666 7.14218L11.9048 11.285L16.3333 11.9041L13.1428 15.0946L13.9524 19.9993L9.66666 17.6184L5.38095 19.9993L6.19047 15.0946L3 11.9041L7.42857 11.285L9.66666 7.14218ZM10.619 7.14218H8.71428C8.19047 7.14218 7.7619 6.71361 7.7619 6.1898V5.71361C7.7619 5.1898 8.19047 4.76123 8.71428 4.76123H10.619C11.1428 4.76123 11.5714 5.1898 11.5714 5.71361V6.1898C11.5714 6.71361 11.1428 7.14218 10.619 7.14218ZM8.71428 5.71361V6.1898H10.619V5.71361H8.71428Z"
                              fill="url(#paint0_linear_544_8183)"
                            />
                            <path
                              d="M9.66666 11.4283C10.2857 11.4283 10.8571 11.6188 11.2857 11.9521L11.8571 11.2854L9.66666 7.14258V11.4283ZM13.1428 15.095L16.3333 11.9045L12.2381 13.095C12.4286 13.4759 12.5238 13.8569 12.5238 14.2854C12.5238 14.4759 12.5238 14.6664 12.4762 14.8092L13.1428 15.095ZM9.66666 17.1426V17.6188L13.9524 19.9997L11.5238 16.4759C11 16.9045 10.3809 17.1426 9.66666 17.1426ZM6.85714 14.8092L6.19047 15.0473L5.38095 19.9997L7.80952 16.4759C7.33333 16.0473 7 15.4759 6.85714 14.8092ZM8.04761 11.9521L7.47619 11.2854L3 11.9045L7.09523 13.095C7.28571 12.6188 7.61904 12.2378 8.04761 11.9521ZM11.5714 14.2854C11.5714 15.333 10.7143 16.1902 9.66666 16.1902C8.61904 16.1902 7.7619 15.333 7.7619 14.2854C7.7619 13.2378 8.61904 12.3807 9.66666 12.3807C10.7143 12.3807 11.5714 13.2378 11.5714 14.2854Z"
                              fill="url(#paint1_linear_544_8183)"
                            />
                            <path
                              d="M4.42773 0H14.9039V2.38095L10.6182 6.19047H8.71344L4.42773 2.38095V0Z"
                              fill="#004577"
                            />
                            <path
                              d="M13.0006 0H6.33398V4.09523L8.71493 6.19047H10.6197L13.0006 4.09523V0Z"
                              fill="#00EAFF"
                            />
                            <path
                              d="M8.71484 0H10.6196V6.19047H8.71484V0Z"
                              fill="#004577"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_544_8183"
                                x1="3"
                                y1="4.76123"
                                x2="18.1032"
                                y2="17.9766"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FDEB71" />
                                <stop offset="1" stopColor="#F8D800" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_544_8183"
                                x1="3"
                                y1="7.14258"
                                x2="15.8486"
                                y2="20.4671"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FD6E6A" />
                                <stop offset="1" stopColor="#FFC600" />
                              </linearGradient>
                            </defs>
                          </svg>
                          <span>{lang?.Awards}</span>
                        </Tab>
                      )}
                    {userType &&
                      userType.role_id === constant.rolesId.voiceOfExpert &&
                      data?.profile_percentage === 100 && (
                        <Tab
                          className="TabInnerList"
                          onClick={() => setContactInfo(false)}
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.875 3.6665H4.125C3.36554 3.6665 2.75 4.28205 2.75 5.0415V15.5832C2.75 16.3422 3.36554 16.9582 4.125 16.9582H5.5V20.1665L9.4215 16.9582H17.875C18.634 16.9582 19.25 16.3422 19.25 15.5832V5.0415C19.25 4.28205 18.634 3.6665 17.875 3.6665Z"
                              fill="url(#paint0_linear_657_18)"
                            />
                            <path
                              d="M7.33333 13.2918L5.5 10.0835V8.7085H9.16667V10.0835L7.33333 13.2918Z"
                              fill="white"
                            />
                            <path
                              d="M9.16663 10.0832L7.3333 9.62484L5.50134 10.0832V2.2915H9.16663V10.0832Z"
                              fill="#004577"
                            />
                            <path
                              d="M6.54773 11.9165L7.33331 13.2915L8.1189 11.9165H6.54773Z"
                              fill="#004577"
                            />
                            <path
                              d="M7.33337 2.2915V9.62484L9.16671 10.0832V2.2915H7.33337Z"
                              fill="#46A7ED"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_657_18"
                                x1="2.75"
                                y1="3.6665"
                                x2="19.25"
                                y2="20.1665"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FFE985" />
                                <stop offset="1" stopColor="#FA742B" />
                              </linearGradient>
                            </defs>
                          </svg>
                          <span>{lang?.Blogs}</span>
                        </Tab>
                      )}
                    {userType &&
                      userType.role_id === constant.rolesId.travelAgencies &&
                      data?.profile_percentage === 100 && (
                        <Tab
                          className="TabInnerList"
                          onClick={() => setContactInfo(false)}
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.5001 5.95842C17.5107 5.95842 18.3334 5.13571 18.3334 4.12508C18.3334 3.11446 17.5107 2.29175 16.5001 2.29175C15.4895 2.29175 14.6667 3.11446 14.6667 4.12508C14.6667 5.13571 15.4895 5.95842 16.5001 5.95842Z"
                              fill="url(#paint0_linear_675_361)"
                            />
                            <path
                              d="M3.24243 18.3816L10.1172 11.5065L10.7654 12.1547L3.89062 19.0298L3.24243 18.3816Z"
                              fill="url(#paint1_linear_675_361)"
                            />
                            <path
                              d="M10.0833 12.8333C9.85049 12.8333 9.61811 12.7457 9.43982 12.5693C9.07911 12.2136 9.07545 11.6333 9.43066 11.2731L13.6702 6.97622C14.0259 6.6146 14.6062 6.61139 14.9664 6.96706C15.3271 7.32272 15.3308 7.90297 14.9756 8.26322L10.736 12.5601C10.5563 12.7425 10.3203 12.8333 10.0833 12.8333Z"
                              fill="url(#paint2_linear_675_361)"
                            />
                            <path
                              d="M6.86346 13.303C6.54996 12.99 6.13975 12.8333 5.72909 12.8333C5.31842 12.8333 4.90821 12.99 4.59471 13.303C4.24454 13.6532 2.65504 15.2427 2.30304 15.5947C1.99046 15.9073 1.83371 16.3166 1.83325 16.7263C1.83279 17.1379 1.98909 17.5495 2.30304 17.8635C2.92959 18.49 3.66659 19.2499 3.66659 19.2499L8.24992 14.6666C8.24992 14.6666 7.05871 13.4983 6.86346 13.303Z"
                              fill="url(#paint3_linear_675_361)"
                            />
                            <path
                              d="M4.12492 17.875C3.8818 17.875 3.64865 17.9716 3.47674 18.1435C3.30483 18.3154 3.20825 18.5486 3.20825 18.7917C3.20825 19.0348 3.30483 19.2679 3.47674 19.4398C3.64865 19.6118 3.8818 19.7083 4.12492 19.7083C4.36803 19.7083 4.60119 19.6118 4.7731 19.4398C4.94501 19.2679 5.04159 19.0348 5.04159 18.7917C5.04159 18.5486 4.94501 18.3154 4.7731 18.1435C4.60119 17.9716 4.36803 17.875 4.12492 17.875Z"
                              fill="url(#paint4_linear_675_361)"
                            />
                            <path
                              d="M15.9774 10.0283L15.0836 12.98L14.387 12.1321L15.322 9.03833L15.9774 10.0283Z"
                              fill="#1976D2"
                            />
                            <path
                              d="M12.7157 12.375L11.9828 15.2249L10.2044 18.337C9.95328 18.7765 10.1059 19.3366 10.5454 19.5878C10.6884 19.6694 10.8452 19.7083 10.9992 19.7083C11.3173 19.7083 11.6267 19.5429 11.7958 19.2463L13.6291 16.038C13.6658 15.9738 13.6947 15.906 13.7148 15.8354L14.7021 12.375H12.7157Z"
                              fill="url(#paint5_linear_675_361)"
                            />
                            <path
                              d="M19.658 10.638L18.0447 9.83134L16.2443 7.14322C16.0454 6.84026 15.7493 6.59871 15.3758 6.48551C15.2222 6.43921 15.0673 6.41722 14.9147 6.41676C14.2235 6.41447 13.5855 6.86134 13.3747 7.55526L11.9855 12.1386C11.8113 12.7138 11.9832 13.3046 12.3696 13.7111C13.0053 14.3798 15.1709 15.9771 15.1709 15.9771L15.5926 18.9196C15.6567 19.378 16.0509 19.708 16.5001 19.708C16.5413 19.708 16.5872 19.7034 16.6284 19.6988C17.089 19.6319 17.419 19.2395 17.4167 18.7913C17.4167 18.7491 17.414 18.706 17.4076 18.663L16.9492 15.4546C16.9263 15.2805 16.853 15.12 16.7384 14.9871L15.0838 12.9787L15.978 10.028L16.6513 11.0455C16.743 11.183 16.8622 11.2884 17.0088 11.3617L18.8422 12.2784C18.9705 12.343 19.1126 12.3751 19.2501 12.3751C19.5847 12.3751 19.9101 12.1918 20.0705 11.8663C20.2951 11.4172 20.1117 10.8672 19.658 10.638Z"
                              fill="url(#paint6_linear_675_361)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_675_361"
                                x1="14.6667"
                                y1="2.29175"
                                x2="18.3334"
                                y2="5.95841"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FD6E6A" />
                                <stop offset="1" stopColor="#FFC600" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_675_361"
                                x1="3.24243"
                                y1="18.3816"
                                x2="4.64854"
                                y2="19.5454"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#F05F57" />
                                <stop offset="1" stopColor="#360940" />
                              </linearGradient>
                              <linearGradient
                                id="paint2_linear_675_361"
                                x1="9.16675"
                                y1="6.70264"
                                x2="15.2971"
                                y2="12.7751"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3C8CE7" />
                                <stop offset="1" stopColor="#00EAFF" />
                              </linearGradient>
                              <linearGradient
                                id="paint3_linear_675_361"
                                x1="1.83325"
                                y1="12.8333"
                                x2="8.24992"
                                y2="19.2499"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FFAA85" />
                                <stop offset="1" stopColor="#B3315F" />
                              </linearGradient>
                              <linearGradient
                                id="paint4_linear_675_361"
                                x1="3.20825"
                                y1="17.875"
                                x2="5.04158"
                                y2="19.7083"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#F05F57" />
                                <stop offset="1" stopColor="#360940" />
                              </linearGradient>
                              <linearGradient
                                id="paint5_linear_675_361"
                                x1="10.0835"
                                y1="12.375"
                                x2="16.6973"
                                y2="16.5404"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3C8CE7" />
                                <stop offset="1" stopColor="#00EAFF" />
                              </linearGradient>
                              <linearGradient
                                id="paint6_linear_675_361"
                                x1="11.9175"
                                y1="6.41675"
                                x2="23.8277"
                                y2="13.8085"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3C8CE7" />
                                <stop offset="1" stopColor="#00EAFF" />
                              </linearGradient>
                            </defs>
                          </svg>
                          <span>{lang?.Trips}</span>
                        </Tab>
                      )}
                    {userType &&
                      (userType.role_id === constant.rolesId.restaurant ||
                        userType.role_id === constant.rolesId.voiceOfExpert ||
                        userType.role_id === constant.rolesId.importer ||
                        userType.role_id === constant.rolesId.distributer ||
                        userType.role_id ===
                          constant.rolesId['importer&distributer']) &&
                      data?.profile_percentage === 100 && (
                        <Tab
                          className="TabInnerList"
                          onClick={() => setContactInfo(false)}
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.7812 6.125C12.9369 6.125 12.25 5.43813 12.25 4.59375C12.25 3.74938 12.9369 3.0625 13.7812 3.0625C14.6256 3.0625 15.3125 3.74938 15.3125 4.59375C15.3125 5.43813 14.6256 6.125 13.7812 6.125ZM5.90625 6.5625C6.75062 6.5625 7.4375 5.87563 7.4375 5.03125C7.4375 4.18688 6.75062 3.5 5.90625 3.5C5.06188 3.5 4.375 4.18688 4.375 5.03125C4.375 5.87563 5.06188 6.5625 5.90625 6.5625Z"
                              fill="url(#paint0_linear_294_646)"
                            />
                            <path
                              d="M16.625 8.31248L16.268 11.8816L17.4077 14.9209C17.4497 15.0049 17.4777 15.095 17.4908 15.1882L17.9283 18.2507C17.9966 18.7294 17.6641 19.1721 17.1863 19.2408C16.7086 19.3099 16.2654 18.977 16.1963 18.4988L15.7789 15.5767L14.4375 13.125L12.6223 15.6638L11.7788 18.6156C11.669 18.9997 11.3186 19.2504 10.9379 19.2504C10.8583 19.2504 10.7774 19.2395 10.6969 19.2163C10.2323 19.0833 9.96319 18.5994 10.0962 18.1344L10.9712 15.0719C10.9922 14.9984 11.0228 14.9279 11.0622 14.8623L12.8209 11.4861L13.125 8.74998L11.3313 10.1592L10.9283 12.5768C10.8749 12.8975 10.5967 13.125 10.2821 13.125C10.2463 13.125 10.2099 13.1219 10.1732 13.1158C9.81619 13.0563 9.57425 12.7181 9.63419 12.3602L10.0717 9.73523C10.0944 9.60048 10.1583 9.47579 10.255 9.37954L12.4425 7.19204C12.5453 7.08879 12.6805 7.02273 12.8249 7.00479L15.5706 6.60711L16.7059 4.71492L18.0071 2.11267C18.1694 1.78892 18.5631 1.65767 18.8878 1.81911C19.2119 1.98142 19.3432 2.37517 19.1813 2.69979L17.8688 5.32479C17.8609 5.33967 17.8531 5.35454 17.8443 5.36898L16.625 8.31248ZM9.95225 5.39523C10.0647 5.22679 10.0927 5.01592 10.0288 4.82342L9.15381 2.19842C9.03963 1.85498 8.66819 1.66904 8.32388 1.78367C7.98 1.89829 7.7945 2.26973 7.90913 2.61361L8.68263 4.93411L7.27344 7.04811L4.82606 7.39767L3.10931 5.68092L3.49125 3.38929C3.55075 3.03186 3.30925 2.69323 2.95181 2.63417C2.59175 2.57511 2.25575 2.81617 2.19669 3.17317L1.75919 5.79817C1.72419 6.00773 1.79244 6.22036 1.9425 6.37042L4.11644 9.27936C3.09225 11.3216 2.70594 11.3798 2.63769 12.3283C2.61581 12.4582 2.61013 12.5829 2.625 12.6875C2.625 12.7697 2.63856 12.8397 2.65781 12.9036L3.50875 18.4988C3.577 18.9774 4.0215 19.3099 4.49881 19.2408C4.977 19.1725 5.3095 18.7294 5.24081 18.2507L4.8125 13.125C4.97831 13.0677 5.16863 12.869 5.334 12.8039L6.93613 15.0237L6.15125 18.1628C6.034 18.6318 6.31925 19.1069 6.78781 19.2242C6.85913 19.2421 6.93044 19.2504 7.00088 19.2504C7.39288 19.2504 7.74944 18.9853 7.84875 18.5876L8.72375 15.0876C8.7815 14.857 8.74256 14.6129 8.617 14.4117L7.4375 11.8125L7.875 9.18748L9.95225 5.39523Z"
                              fill="url(#paint1_linear_294_646)"
                            />
                            <path
                              d="M4.84312 13.0856L4.8125 13.125L4.86719 13.3989L4.84312 13.0856Z"
                              fill="#1976D2"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_294_646"
                                x1="4.375"
                                y1="3.0625"
                                x2="6.40693"
                                y2="9.41228"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FCCF31" />
                                <stop offset="1" stopColor="#F55555" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_294_646"
                                x1="1.75018"
                                y1="1.74982"
                                x2="19.2508"
                                y2="19.2503"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#79F1A4" />
                                <stop offset="1" stopColor="#0E5CAD" />
                              </linearGradient>
                            </defs>
                          </svg>
                          <span>{lang?.Events}</span>
                        </Tab>
                      )}
                  </TabList>
                  <TabPanel>
                    {data?.profile_percentage === 100 && (
                      <div className="tab-content-section">
                        <UserSocialPost />{' '}
                      </div>
                    )}
                    {data?.profile_percentage !== 100 && (
                      <div className="card card--block">
                        {' '}
                        <div className="post--form">
                          {' '}
                          <p>
                            {
                              lang?.COMPLETE_YOUR_PROFILE_IN_ORDER_TO_START_POSTING
                            }
                          </p>{' '}
                        </div>{' '}
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel>
                    <div className="card card--block">
                      <div className="user_all_detail">
                        <div className="postGallery">
                          <ul className="flex flex-wrap">
                            {userPostPhotos?.length == 0 && (
                              <div className="post--form emptyData w-full">
                                <div className="empty_notification">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="84.206"
                                    height="67.365"
                                    viewBox="0 0 84.206 67.365"
                                  >
                                    <path
                                      id="icons8_image"
                                      d="M0,5V72.364H84.206V5ZM3.368,8.368H80.837V52.155H62.852L51.063,43.735H41.116l-6.881-6.881-8.2,1.645L18.788,27.617,3.368,43.037Zm59.786,10.1a7.579,7.579,0,1,0,7.578,7.579A7.606,7.606,0,0,0,63.154,18.473Zm0,3.368a4.21,4.21,0,1,1-4.21,4.21A4.189,4.189,0,0,1,63.154,21.841ZM18.262,32.906l6.223,9.328,8.644-1.724L39.721,47.1H49.984l11.789,8.421H80.837V69H3.368V47.8Z"
                                      transform="translate(0 -5)"
                                    />
                                  </svg>
                                  <h3 className="font-20 font-bold mt-5 mb-3">
                                    {lang?.Photos}
                                  </h3>
                                  <h4 className="font-18 text-normal text-black">
                                    {lang?.there_is_no_photo_at_this_moment}
                                  </h4>
                                </div>
                              </div>
                            )}
                            {userPostPhotos?.length >= 0 &&
                              userPostPhotos?.map((item, index) => {
                                return (
                                  <li className="w-1/3" key={index}>
                                    <img
                                      src={`${item?.url}`}
                                      alt="Post Image"
                                      onClick={() =>
                                        handlePhotos(
                                          getUserPost,
                                          `${item?.url}`
                                        )
                                      }
                                      // onClick={() => history.push(`${"/home/post/activity/"}${item?.action_id}`)}
                                    />
                                    {/* <img src={`${item && item.attachment_link && item.attachment_link.base_url}${item && item.attachment_link && item.attachment_link.attachment_url}`} alt="Post Image" /> */}
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    {/*second about Views */}
                    <div className="card card--block">
                      <div className="profile-options-lists">
                        <div className="user_all_detail">
                          {profileData?.data?.about_tab
                            ?.filter((item) => item.value !== '0%')
                            .map((item, index) => {
                              if (item.type === 'checkbox') {
                                let val = [...new Set(item?.value.split(','))];
                                return (
                                  <Fragment key={index}>
                                    <div className="blockRow">
                                      <h4 className="font-size-18 pb-2">
                                        {' '}
                                        {item.title}
                                      </h4>
                                      <div className="selectedProduct">
                                        <ul>
                                          {val?.length > 0 &&
                                            val?.map((v, i) => (
                                              <li>
                                                <Link to="#" key={i}>
                                                  {v}
                                                </Link>
                                              </li>
                                            ))}
                                        </ul>
                                      </div>
                                    </div>
                                  </Fragment>
                                );
                              }
                              if (item.type === 'multiselect') {
                                return (
                                  <Fragment key={index}>
                                    <div className="blockRow">
                                      <h4 className="font-size-18 pb-2">
                                        {item.title}
                                      </h4>
                                      <p className="">{item.value}</p>
                                    </div>
                                  </Fragment>
                                );
                              } else {
                                return (
                                  <Fragment key={index}>
                                    <div className="blockRow">
                                      <h4 className="font-size-18 pb-2">
                                        {item.title}
                                      </h4>
                                      {item.type === 'text' ? (
                                        <Fragment>
                                          {/* {item.value} */}
                                          {/* <SeeMore item={item} /> */}
                                          <ReactReadMoreReadLess
                                            charLimit={150}
                                            readMoreText={'See more'}
                                            readLessText={'See less'}
                                            readMoreClassName="read-more-less--more"
                                            readLessClassName="read-more-less--less"
                                          >
                                            {item?.value}
                                          </ReactReadMoreReadLess>
                                        </Fragment>
                                      ) : (
                                        <p className="">{item.value}</p>
                                      )}
                                    </div>
                                  </Fragment>
                                );
                              }
                            })}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="card card--block">
                      <Contact />
                    </div>
                  </TabPanel>
                  {userType?.role_id !== constant.rolesId.voyagers && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">{lang?.Awards} </h4>
                          <div className="editProfileBtn">
                            {' '}
                            <Link to="/create-award" className="btn btnPrimary">
                              {' '}
                              {lang?.Add_Award}
                            </Link>
                          </div>
                        </div>
                        <AwardView />
                      </div>
                    </TabPanel>
                  )}
                  {userType?.role_id === constant.rolesId.voiceOfExpert && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">My Blogs</h4>
                          <div className="editProfileBtn">
                            <Link to="/create-blog" className="btn btnPrimary">
                              {lang?.Add_Blogs}
                            </Link>
                          </div>
                        </div>
                        <BlogView />
                      </div>
                    </TabPanel>
                  )}
                  {userType?.role_id === constant.rolesId.travelAgencies && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">{lang?.Trips}</h4>
                          <div className="editProfileBtn">
                            <Link to="/create-trips" className="btn btnPrimary">
                              {' '}
                              {lang?.Create} {lang?.Trip}{' '}
                            </Link>{' '}
                          </div>
                        </div>
                        <TripView />
                      </div>
                    </TabPanel>
                  )}
                  {(userType?.role_id === constant.rolesId.restaurant ||
                    userType?.role_id === constant.rolesId.voiceOfExpert ||
                    userType?.role_id === constant.rolesId.importer ||
                    userType?.role_id === constant.rolesId.distributer ||
                    userType?.role_id ===
                      constant.rolesId['importer&distributer']) && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">{lang?.Events}</h4>
                          <div className="editProfileBtn">
                            <Link to="/create-event" className="btn btnPrimary">
                              {lang?.Create} {lang?.Events}
                            </Link>
                          </div>
                        </div>
                        <EventView />
                      </div>
                    </TabPanel>
                  )}
                </Tabs>
              </div>
            </div>

            {/* Tab Content Right Section */}

            <div className="tab-content-right-section md:order-1 sm:order-1 xl:order-2 lg:order-2">
              {data?.profile_percentage === 100 && (
                <Fragment>
                  <div className="card card--block hideDesktop">
                    {/* {
                          profileData &&
                          profileData.data &&
                          profileData.data.user_data&&profileData.data.user_data.available_to_connect 
                        } */}
                    <div className="flex flex-wrap items-center justify-between rightBlockBtn">
                      <div className="editProfileBtn">
                        <div className="edit__profile editBtn">
                          <span
                            className="edit__profile-btn"
                            onClick={() => handleEditProfile()}
                          >
                            {' '}
                            {lang?.Edit}{' '}
                          </span>
                          <span
                            className="edit__pics"
                            onClick={() => setchangeProfile(!changeProfile)}
                          >
                            <i className="fas fa-caret-down" />{' '}
                          </span>
                          {changeProfile ? (
                            <div className="edit__options">
                              <form className="profile__upload">
                                <label>
                                  <input
                                    type="file"
                                    name="avatar"
                                    id="avatar_id"
                                    onChange={(e) => {
                                      changeAvatar(e);
                                      setchangeProfile(false);
                                    }}
                                  />{' '}
                                  {lang?.Change_Profile_Photo}
                                </label>
                                <label>
                                  <input
                                    type="file"
                                    name="cover"
                                    id="cover_id"
                                    accept="image/png,image/jpeg"
                                    onChange={(e) => {
                                      changeAvatar(e);
                                      setchangeProfile(false);
                                    }}
                                  />{' '}
                                  {lang?.Change_Banner}
                                </label>
                              </form>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="editProfileBtn">
                        <Link to="/setting" className="btn btnPrimary Icon">
                          <span>
                            <img src={settingicon} />
                            {/* <svg
                              width="20"
                              height="19"
                              viewBox="0 0 24 23"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M22.634 9.37872L20.2883 8.77544C20.1691 8.44402 20.0282 8.12012 19.8665 7.80567L20.9847 5.89328C21.1874 5.55607 21.2684 5.16421 21.2152 4.7784C21.162 4.39259 20.9775 4.03435 20.6904 3.75918L20.0805 3.17475C19.7934 2.89956 19.4196 2.72278 19.017 2.6718C18.6144 2.62081 18.2055 2.69846 17.8536 2.89272L15.8581 3.9643C15.53 3.80932 15.192 3.67432 14.8462 3.5601L14.2167 1.31213C14.1116 0.935675 13.8798 0.602986 13.5573 0.365722C13.2347 0.128459 12.8394 -0.000102857 12.4328 6.17454e-08H11.5672C11.1613 5.09783e-05 10.7667 0.128331 10.4445 0.364985C10.1223 0.601638 9.89047 0.933469 9.78492 1.30911L9.15541 3.55708C8.80954 3.67123 8.47156 3.80623 8.14348 3.96128L6.14715 2.89046C5.79527 2.6962 5.38638 2.61855 4.98379 2.66953C4.58121 2.72052 4.2074 2.8973 3.92026 3.17249L3.31043 3.75692C3.02315 4.03202 2.8386 4.39027 2.7854 4.77611C2.73219 5.16195 2.81329 5.55384 3.01613 5.89102L4.13429 7.80341C3.97259 8.11785 3.83172 8.44175 3.71252 8.77318L1.36603 9.37646C0.973924 9.47765 0.62757 9.69991 0.380614 10.0088C0.133658 10.3178 -0.000119861 10.6961 8.05815e-08 11.0852V11.9148C5.32109e-05 12.3038 0.133911 12.6819 0.380853 12.9907C0.627796 13.2995 0.974054 13.5216 1.36603 13.6228L3.71174 14.2261C3.83085 14.5575 3.97172 14.8814 4.13351 15.1958L3.01613 17.109C2.81342 17.4462 2.7324 17.8381 2.7856 18.2239C2.8388 18.6097 3.02327 18.9679 3.31043 19.2431L3.92026 19.8275C4.20733 20.1028 4.58115 20.2797 4.98377 20.3307C5.38638 20.3817 5.79531 20.3039 6.14715 20.1095L8.14269 19.038C8.4708 19.1929 8.80879 19.3279 9.15462 19.4422L9.78413 21.6901C9.88957 22.066 10.1214 22.3981 10.4438 22.6349C10.7662 22.8718 11.161 23.0001 11.5672 23H12.4328C12.8387 22.9999 13.2333 22.8717 13.5555 22.635C13.8777 22.3984 14.1095 22.0665 14.2151 21.6909L14.8446 19.4429C15.1905 19.3288 15.5284 19.1938 15.8565 19.0387L17.8521 20.1103C18.2039 20.3046 18.6128 20.3822 19.0154 20.3312C19.418 20.2802 19.7918 20.1035 20.079 19.8283L20.6888 19.2438C20.9759 18.9687 21.1604 18.6104 21.2136 18.2246C21.2668 17.8388 21.1858 17.4469 20.9831 17.1097L19.8649 15.1973C20.0266 14.8829 20.1675 14.559 20.2867 14.2276L22.6324 13.6243C23.0249 13.5234 23.3717 13.3011 23.619 12.992C23.8663 12.6829 24.0002 12.3042 24 11.9148V11.0852C23.9997 10.6964 23.8658 10.3186 23.6188 10.0101C23.3719 9.70159 23.0258 9.47969 22.634 9.37872Z"
                                fill="url(#paint0_linear_526_8319)"
                              />
                              <path
                                d="M11.9998 7.07715C11.0871 7.07715 10.1948 7.33654 9.43585 7.82252C8.6769 8.3085 8.08538 8.99925 7.73607 9.80741C7.38677 10.6156 7.29537 11.5048 7.47344 12.3628C7.65152 13.2207 8.09106 14.0088 8.73649 14.6273C9.38192 15.2459 10.2043 15.6671 11.0995 15.8377C11.9947 16.0084 12.9227 15.9208 13.766 15.5861C14.6093 15.2513 15.33 14.6844 15.8371 13.9571C16.3443 13.2298 16.6149 12.3747 16.6149 11.4999C16.6149 10.3269 16.1287 9.20199 15.2632 8.37255C14.3977 7.54312 13.2238 7.07715 11.9998 7.07715Z"
                                fill="url(#paint1_linear_526_8319)"
                              />
                              <path
                                d="M12.0003 9.73096C11.6352 9.73096 11.2783 9.83471 10.9747 10.0291C10.6712 10.2235 10.4345 10.4998 10.2948 10.8231C10.1551 11.1463 10.1185 11.502 10.1898 11.8452C10.261 12.1884 10.4368 12.5036 10.695 12.751C10.9532 12.9984 11.2821 13.1669 11.6402 13.2352C11.9983 13.3035 12.3695 13.2684 12.7068 13.1345C13.0441 13.0006 13.3324 12.7739 13.5352 12.4829C13.7381 12.192 13.8464 11.85 13.8464 11.5001C13.8464 11.0309 13.6519 10.5809 13.3057 10.2491C12.9595 9.91735 12.4899 9.73096 12.0003 9.73096Z"
                                fill="white"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_526_8319"
                                  x1="0"
                                  y1="0"
                                  x2="23.6436"
                                  y2="11.1516"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#8160FE" />
                                  <stop offset="1" stopColor="#44DBDC" />
                                </linearGradient>
                                <linearGradient
                                  id="paint1_linear_526_8319"
                                  x1="7.38477"
                                  y1="7.07715"
                                  x2="16.5804"
                                  y2="9.0922"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#05B3D3" />
                                  <stop offset="1" stopColor="#C081D3" />
                                </linearGradient>
                              </defs>
                            </svg> */}
                          </span>
                          {lang?.Settings}
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* Fearture Products */}
                  {profileData &&
                  profileData.data &&
                  profileData.data.products.length > 0 ? (
                    <div className="card card--block">
                      <div
                        className={
                          featureProductTabModel
                            ? 'featured__products profile__option--selected'
                            : 'featured__products'
                        }
                      >
                        <div className="block__title flex justify-between">
                          <p>{profileData.data.products[0].title}</p>
                          {/* <p>Featured Products</p> */}
                          {/* <span>
                                <button onClick={() => setOpenModel(true)}>
                                  <i className="fas fa-plus-circle" />
                                </button>
                              </span> */}
                        </div>

                        <div className="featureWrapper pt-4">
                          <div className="w-1/2">
                            <div className="addFeaturePrdct img_container">
                              <button
                                onClick={() => {
                                  setOpenModel(true);
                                  setTabModel(true);
                                }}
                              >
                                <i className="fas fa-plus-circle" />
                              </button>
                            </div>
                            <div>
                              {userType?.role_id ===
                                constant.rolesId.voiceOfExpert && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.Add_Featured}
                                </p>
                              )}
                              {userType?.role_id ===
                                constant.rolesId.restaurant && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.Add_Menu}
                                </p>
                              )}
                              {userType?.role_id ===
                                constant.rolesId.travelAgencies && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.add_package}
                                </p>
                              )}
                              {userType?.role_id ===
                                constant.rolesId.producer && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.add_product}
                                </p>
                              )}
                              {userType?.role_id ===
                                constant.rolesId.importer && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.add_product}
                                </p>
                              )}
                              {userType?.role_id ===
                                constant.rolesId.distributer && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.add_product}
                                </p>
                              )}
                              {userType?.role_id ===
                                constant.rolesId['importer&distributer'] && (
                                <p className="text-center font-semibold text-blue">
                                  {lang?.add_product}
                                </p>
                              )}
                            </div>
                          </div>
                          {profileData?.data ? (
                            profileData.data.products.map((item) => {
                              return (
                                <Fragment>
                                  {item.products.map((res) => {
                                    return (
                                      <div className="featured__products">
                                        <div className="">
                                          <div className="w-1/2 mb-2">
                                            <div className="img_container">
                                              <span
                                                className="featured-product-delete"
                                                onClick={() => {
                                                  setDeleteFeaturedProduct(
                                                    true
                                                  );
                                                  setfeaturedProductId(
                                                    res.featured_listing_id
                                                  );
                                                }}
                                              >
                                                <i className="far fa-trash-alt" />
                                              </span>
                                              <div
                                                onClick={() => {
                                                  handleFeatureProductEdit(
                                                    res.featured_listing_id
                                                  );
                                                  setFeatureProductUpdate(true);setHide(true)
                                                }}
                                              >
                                                <img
                                                  src={
                                                    res &&
                                                    res.image !== null &&
                                                    res &&
                                                    res.image &&
                                                    `${res?.image?.base_url}${res?.image?.attachment_thumbnail_url}`
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div
                                              style={{ textAlign: 'center' }}
                                            >
                                              <a
                                                // href={res?.listing_url}
                                                // target="_blank"
                                                 onClick={() => {
                                                  handleFeatureProductEdit(
                                                    res.featured_listing_id
                                                  );
                                                  setFeatureProductUpdate(true);setHide(false)
                                                }}
                                              >
                                                {' '}
                                                <p>{res.title}</p>
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </Fragment>
                              );
                            })
                          ) : (
                            <div className="featured__products">
                              <div className="img_container">
                                <span className="featured-product-delete">
                                  <i className="far fa-trash-alt" />
                                </span>
                                {/* <img src={F1} /> */}
                                <p>{lang?.Nothing_added_yet}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {/* Fearture Products */}
                </Fragment>
              )}
              {data?.profile_percentage !== 100 && (
                <div className="card card--block">
                  <div className="profile-options-lists">
                    <div className="options-list-item">
                      <p className="list-title">{lang?.Update_Profile}</p>
                      <div className="list-item-name">
                        {data ? (
                          <>
                            <Line
                              percent={parseInt(data?.profile_percentage)}
                              strokeWidth="4"
                              strokeColor="#2db7f5"
                            />
                            <span>
                              {' '}
                              {data &&
                                `${parseInt(
                                  data?.profile_percentage
                                )}% complete`}{' '}
                            </span>
                            {/* <span> {data && `${data?.profile_percentage}% complete`} </span> */}
                          </>
                        ) : null}
                      </div>
                    </div>
                    {data_progress
                      ? data_progress?.map((item) => {
                          if (item.redirect_to === 'edit_contact') {
                            return (
                              <div className="options-list-item">
                                <div className="list-item-name">
                                  {item.status ? (
                                    <p
                                      className="list-title"
                                      name={item.title}
                                      onClick={() => handleProfileTab(item)}
                                    >
                                      <span style={{ paddingRight: 10 }}>
                                        <i className="fas fa-check-circle" />
                                      </span>
                                      {item.title}
                                    </p>
                                  ) : (
                                    <p
                                      className="list-title"
                                      onClick={() => handleProfileTab(item)}
                                    >
                                      <span style={{ paddingRight: 10 }}>
                                        <i className="fas fa-plus-circle" />
                                      </span>
                                      {item.title}
                                    </p>
                                  )}
                                </div>
                              </div>
                            );
                          }
                          return (
                            <div className="options-list-item">
                              <div className="list-item-name">
                                {item.status ? (
                                  <p
                                    className="list-title"
                                    name={item.title}
                                    onClick={() => handleProfileTab(item)}
                                  >
                                    <span style={{ paddingRight: 10 }}>
                                      <i className="fas fa-check-circle" />
                                    </span>
                                    {item.title === 'Hub Selection' ? (
                                      <Link to="/hubs"> {item.title}</Link>
                                    ) : (
                                      item.title
                                    )}
                                  </p>
                                ) : (
                                  <p
                                    className="list-title"
                                    onClick={() => handleProfileTab(item)}
                                  >
                                    <span style={{ paddingRight: 10 }}>
                                      <i className="fas fa-plus-circle" />
                                    </span>
                                    {item.title}
                                  </p>
                                )}
                              </div>
                            </div>
                          );
                        })
                      : ''}
                  </div>
                </div>
              )}
            </div>

            {/*End Tab Content Right Section */}

            {/* edit contact modal */}
            {editContactModel && <EditContact />}
          </div>
        </div>
      </div>

      {/* -----------------------Modal------------------------------------ */}
      <Modal
        ariaHideApp={false}
        isOpen={openModel}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
          },
          content: {
            position: 'absolute',
            top: '140px',
            left: '30%',
            right: '30%',
            bottom: '200px',
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            // outline: 'none',
            padding: '20px',
          },
        }}
      >
        <button
          className="close_btn--modal"
          onClick={() => {
            handleModel();
          }}
        >
          {lang?.close}
        </button>

        {(profileData && profileData.data) ||
        (editFeatureProductData && editFeatureProductData.fields) ? (
          <form>
            {tabModel &&
              profileData?.data?.products &&
              profileData?.data?.products?.length > 0 &&
              profileData?.data?.products[0].fields &&
              profileData?.data?.products[0].fields?.map((item) => {
                if (item.featured_listing_type_id) {
                  featureProduct['featured_listing_type_id'] =
                    item.featured_listing_type_id;
                }
                if (item.name === 'listing_url') {
                  return (
                    <div className="form__item">
                      <label>{item.title}</label>
                      <input
                        value={url}
                        type={item.type}
                        name={item.name}
                        id={item.featured_listing_field_id}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div className="form__item">
                      <label style={{display:hide==true?"none":""}}>
                        {item.title}
                        {item.type == 'file' && (
                          <> ({lang?.Recommend_Size_900_900}) </>
                        )}
                      </label>
                      {item.type == 'file' &&
                        featuredProductImageUrl !== '' && (
                          <Cropper
                            zoomTo={0}
                            style={{ width: '100%' }}
                            preview=".img-preview"
                            src={featuredProductImageUrl}
                            viewMode={1}
                            dragMode={'move'}
                            cropBoxMovable={false}
                            responsive={true}
                            cropBoxResizable={false}
                            ref={cropper}
                            initialAspectRatio={2 / 2}
                            center={true}
                            guides={false}
                          />
                        )}
                      <input
                        type={item.type}
                        name={item.name}
                        id={item.featured_listing_field_id}
                        onChange={(e) => handleChange(e)}
                      />
                      {item.type == 'file' && errMessage?.msg?.image_req && (
                        <div style={{display:hide==true?"none":""}} ref={featureProductRef}>
                          <FormError msg={errMessage?.msg?.image_req} />{' '}
                        </div>
                      )}
                      {item.featured_listing_field_id == 2 &&
                        errMessage?.msg?.title_req && (
                          <div style={{display:hide==true?"none":""}} ref={featureProductRef}>
                            <FormError msg={errMessage?.msg?.title_req} />{' '}
                          </div>
                        )}

                      {item.featured_listing_field_id == 8 &&
                        errMessage?.msg?.url_and_description && (
                          <div style={{display:hide==true?"none":""}} ref={featureProductRef}>
                            <FormError
                              msg={errMessage?.msg?.url_and_description}
                            />{' '}
                          </div>
                        )}

                      {/* {errMessage.field == "title" ? (
                      <div ref={featureProductRef}><FormError msg={errMessage.title_req} /> </div>
                    ) : null} */}
                    </div>
                  );
                }
              })}
            {featureProductUpdate &&
              editFeatureProductData?.fields?.map((item) => {
                if (item.featured_listing_type_id) {
                  featureProduct['featured_listing_type_id'] =
                    item.featured_listing_type_id;
                }

                if (item.name === 'listing_url') {
                  return (
                    <div className={`form__item ${hide==true?"d-none":""} `}>
                      <label>{item.title}</label>
                      <input
                        value={url}
                        type={item.type}
                        name={item.name}
                        id={item.featured_listing_field_id}
                        onChange={(e) => {
                          handleChange(e);
                          setIsUrlStatus(true);
                        }}
                        onClick={() => {
                          item.value &&
                            url.length == 0 &&
                            !isUrlStatus &&
                            setUrl(item.value);
                        }}
                      />
                    </div>
                  );
                }
                return (
                  <div className="form__item">
                    <label style={{display:hide==true?"none":""}}>
                      {item.title}
                      {item.type == 'file' && (
                        <> ({lang?.Recommend_Size_900_900}) </>
                      )}
                    </label>
                    {item.type == 'file' && featuredProductImageUrl === '' && (
                      <img
                        src={
                          imageUrl !== ''
                            ? imageUrl
                            : `${item.base_url}${item.value}`
                        }
                      />
                    )}
                    {item.type == 'file' && featuredProductImageUrl !== '' && (
                      <div className="editFeaturedProduct">
                        <Cropper
                          zoomTo={0}
                          style={{ height: 200, width: '100%' }}
                          preview=".img-preview"
                          src={featuredProductImageUrl}
                          viewMode={1}
                          dragMode={'move'}
                          cropBoxMovable={false}
                          responsive={true}
                          cropBoxResizable={false}
                          ref={cropper}
                          initialAspectRatio={2 / 2}
                          center={true}
                          guides={false}
                        />
                        <button
                          type="button"
                          className="cancelFeaturedProduct"
                          style={{ backgroundColor: '#004577', color: '#FFF' }}
                          onClick={() => setFeaturedProductImageUrl('')}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                    <input
                     style={{display:hide==true?"none":""}}
                      defaultValue={item.type == 'file' ? '' : item.value}
                      type={item.type}
                      name={item.name}
                      id={item.featured_listing_field_id}
                      onChange={(e) => handleChange(e)}
                    />
                    {item.type == 'file' && errMessage?.msg?.image_req && (
                      <div ref={featureProductRef}>
                        <FormError msg={errMessage?.msg?.image_req} />{' '}
                      </div>
                    )}
                    {item.featured_listing_field_id == 2 &&
                      errMessage?.msg?.title_req && (
                        <div ref={featureProductRef}>
                          <FormError msg={errMessage?.msg?.title_req} />{' '}
                        </div>
                      )}

                    {item.featured_listing_field_id == 8 &&
                      errMessage?.msg?.url_and_description && (
                        <div ref={featureProductRef}>
                          <FormError
                            msg={errMessage?.msg?.url_and_description}
                          />{' '}
                        </div>
                      )}
                  </div>
                );
              })}
            <div className="form__action form__item">
              <button
              className={hide==true?"d-none":""}
                type="button"
                disabled={featuredProductButton}
                onClick={(e) => {
                  addFeaturedList(editFeatureProductData);
                }}
              >
                {featuredProductSpinner ? (
                  <FormSpinner />
                ) : featureProductUpdate ? (
                  `${lang?.Update}`
                ) : (
                  `${lang?.Save}`
                )}
              </button>
            </div>
          </form>
        ) : null}
      </Modal>

      {/*about/product....  */}
      {editModelAbout && (
        <Modal
          ariaHideApp={false}
          isOpen={editModelAbout}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
            },
            content: {
              position: 'absolute',
              top: '140px',
              left: '30%',
              right: '30%',
              bottom: '200px',
              border: '1px solid #ccc',
              background: '#fff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              borderRadius: '4px',
              // outline: 'none',
              padding: '20px',
            },
          }}
        >
          <button
            className="close_btn--modal"
            onClick={() => setEditModelAbout(false)}
          >
            {lang?.close}
          </button>
          <form>
            {formField &&
              formField.data &&
              formField.data.step_1.map((item) => {
                if (item.title === tabTitle) {
                  return (
                    <Fragment>
                      <div className="form__item">
                        <label>{item.title}</label>
                        <textarea
                          cols="2"
                          rows="3"
                          name={item.name}
                          defaultValue={item.is_selected}
                          id={item.user_field_id}
                          onChange={(e) => {
                            handleUserField(e);
                            setTextAreaId(e.target.id);
                            setTextAreaValues(e.target.value);
                            setTextAreaState(true);
                          }}
                          maxlength="300"
                        />
                        {textAreaValues.length || textAreaState ? (
                          <p>{`${textAreaValues.length}/300`}</p>
                        ) : (
                          item &&
                          item.is_selected && (
                            <p>{`${item.is_selected.length}/300`}</p>
                          )
                        )}
                      </div>
                      {errMessage.field === item.user_field_id && (
                        <FormError msg={errMessage.msg} />
                      )}
                    </Fragment>
                  );
                }
              })}
            <div className="form__action form__item">
              <button
                type="button"
                disabled={textAreaState ? false : true}
                onClick={(e) => updateUserField(e)}
              >
                {' '}
                {updateUserFieldSpinner ? <FormSpinner /> : `${lang?.Save}`}
              </button>
            </div>
          </form>
        </Modal>
      )}

      {/*Edit profile */}
      {editModel && (
        <Modal
          ariaHideApp={false}
          isOpen={editModel}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
            },
            content: {
              position: 'absolute',
              top: '140px',
              left: '30%',
              right: '30%',
              bottom: '200px',
              border: '1px solid #ccc',
              background: '#fff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              borderRadius: '4px',
              // outline: 'none',
              padding: '20px',
            },
          }}
        >
          <button
            className="close_btn--modal"
            onClick={() => setEditModel(false)}
          >
            {' '}
            {lang?.close}
          </button>
          {formField?.data?.step_1?.length > 0 ? (
            <form>
              {formField && formField.data
                ? formField.data.step_1.map((field, j) => {
                    if (
                      (field.is_selected && field.type === 'email') ||
                      field.type === 'password' ||
                      field.type === 'text'
                    ) {
                      formValue[field.user_field_id] = field.is_selected;
                    }
                    if (
                      field.type === 'email' ||
                      field.type === 'password' ||
                      field.type === 'text'
                    ) {
                      return (
                        <Fragment key={j}>
                          {otherCity && field.name === 'enter_your_city' ? (
                            <Input
                              key={field.user_field_id}
                              type={
                                field.name === 'vat_no' ? 'number' : field.type
                              }
                              placeholder={field.placeholder}
                              name={field.name}
                              label={field.title}
                              id={field.user_field_id}
                              value={field.is_selected}
                              onChange={(e) => {
                                handleInput(e);
                              }}
                            />
                          ) : field.name === 'about' ? (
                            <Textarea
                              key={field.user_field_id}
                              type={field.type}
                              placeholder={field.placeholder}
                              value={field.is_selected}
                              name={field.name}
                              label={field.title}
                              id={field.user_field_id}
                              onChange={(e) => {
                                handleInput(e);
                                setTextAreaState(true);
                              }}
                              maxlength="300"
                            />
                          ) : (
                            field.name !== 'enter_your_city' && (
                              <Input
                                key={field.user_field_id}
                                type={
                                  field.name === 'vat_no'
                                    ? 'number'
                                    : field.type
                                }
                                placeholder={field.placeholder}
                                name={field.name}
                                label={field.title}
                                id={field.user_field_id}
                                value={field.is_selected}
                                onChange={(e) => {
                                  handleInput(e);
                                  setTextAreaState(true);
                                }}
                                maxlength="300"
                              />
                            )
                          )}
                          {/* {fieldInputValues && fieldInputValues[field.user_field_id] || textAreaState ? <p>{`${fieldInputValues && fieldInputValues[field.user_field_id].length}/300`}</p> : field?.is_selected && <p>{`${field?.is_selected.length}/300`}</p>} */}
                          {errMessage.field === field.name && (
                            <FormError msg={errMessage.msg} />
                          )}
                          {field.type === 'password' && (
                            <PasswordIndicator
                              specialChar={specialChar}
                              digits={digits}
                              strLength={strLength}
                            />
                          )}
                        </Fragment>
                      );
                    } else if (field.type == 'checkbox') {
                      return (
                        <Fragment key={j}>
                          {errMessage.field === field.name && <div id="product__type" ref={myRef}> <FormError msg={errMessage.msg} /> </div>}
                          <Checkbox
                            key={field.user_field_id}
                            label={field.title}
                            type={field.type}
                            placeholder={field.placeholder}
                            Options={field.options}
                            id={field.user_field_id}
                            Ref={field.user_field_id}
                            selectedCheckbox={productTypeList}
                            onChange={(e, isDefault) => {
                              handleCheckBox(e, isDefault);
                            }}
                          />
                        </Fragment>
                      );
                    } else if (field.type === 'select') {
                      return (
                        <Fragment key={j}>
                          {(Pickup &&
                            field.name ===
                              'pick_up_discount_for_alysei_voyagers') ||
                          (delevery &&
                            field.name ===
                              'delivery_discount_for_alysei_voyagers') ? (
                            <Select
                              key={field.user_field_id}
                              label={field.title}
                              type={field.type}
                              placeholder={field.placeholder}
                              Options={field.options}
                              id={
                                field.user_field_id
                                  ? field.user_field_id
                                  : field.name
                              }
                              apiCall={field.api_call}
                              onChange={(e) => handleInput(e)}
                            />
                          ) : field.name !==
                            'pick_up_discount_for_alysei_voyagers' ? (
                            <>
                              {field.name !==
                              'delivery_discount_for_alysei_voyagers' ? (
                                <Select
                                  key={field.user_field_id}
                                  label={field.title}
                                  type={field.type}
                                  placeholder={field.placeholder}
                                  Options={
                                    field.api_call && field.name === 'country'
                                      ? countries
                                      : field.api_call && field.name === 'state'
                                      ? regions
                                      : field.api_call && field.name === 'city'
                                      ? cities
                                      : field.options
                                  }
                                  id={
                                    field.user_field_id
                                      ? field.user_field_id
                                      : field.name
                                  }
                                  apiCall={
                                    field.name === 'city'
                                      ? 'true'
                                      : field.api_call
                                  }
                                  onChange={(e) => handleInput(e)}
                                />
                              ) : (Pickup &&
                                  field.name ===
                                    'pick_up_discount_for_alysei_voyagers') ||
                                (delevery &&
                                  field.name ===
                                    'delivery_discount_for_alysei_voyagers') ? (
                                <Select
                                  key={field.user_field_id}
                                  label={field.title}
                                  type={field.type}
                                  placeholder={field.placeholder}
                                  Options={field.options}
                                  id={
                                    field.user_field_id
                                      ? field.user_field_id
                                      : field.name
                                  }
                                  apiCall={field.api_call}
                                  onChange={(e) => handleInput(e)}
                                />
                              ) : null}
                            </>
                          ) : null}
                          {errMessage.field === field.name && (
                            <FormError msg={errMessage.msg} />
                          )}
                        </Fragment>
                      );
                    } else if (field.type === 'radio') {
                      return (
                        <Fragment key={j}>
                          <Select
                            key={field.user_field_id}
                            label={field.title}
                            type={field.type}
                            placeholder={field.placeholder}
                            Options={field.options}
                            apiCall={field.api_call}
                            id={field.user_field_id}
                            onChange={(e) => handleInput(e)}
                          />
                          {errMessage.field === field.name && (
                            <FormError msg={errMessage.msg} />
                          )}
                        </Fragment>
                      );
                    } else if (field.type === 'terms') {
                      return (
                        <Fragment key={j}>
                          <Terms
                            key={field.user_field_id}
                            label={field.title}
                            type={field.type}
                            id={field.user_field_id}
                            onChange={(e) => handleInput(e)}
                          />
                          {errMessage.field === field.name && (
                            <FormError msg={errMessage.msg} />
                          )}
                        </Fragment>
                      );
                    } else if (field.type === 'multiselect') {
                      return (
                        <Fragment key={j}>
                          <MultiSelecter
                            displayValue={'option'}
                            id={field.user_field_id}
                            Options={field.options}
                            label={field.title}
                            // Value={formValue[field.user_field_id]}
                            Ref={field.user_field_id}
                            fireData={(id, selectedList) =>
                              handleMultiSelect(id, selectedList)
                            }
                          />
                          {errMessage.field === field.name && (
                            <FormError msg={errMessage.msg} />
                          )}
                        </Fragment>
                      );
                    } else if (field.type === 'map') {
                      return (
                        <Fragment key={j}>
                          <div
                            className="form__item"
                            style={{ paddingBottom: 40 }}
                          >
                            <Map
                              google={props.google}
                              center={{ lat: 41.878, lng: -87.63 }}
                              height="300px"
                              zoom={15}
                            />
                          </div>
                        </Fragment>
                      );
                    }
                  })
                : 'hold on content loading'}
              <div className="form__action form__item">
                {/* <button type="button" onClick={(e) => editProfile(e)}> {updateProfileSpinner ? <FormSpinner /> : "Update"} </button> */}
                <button type="button" onClick={(e) => editProfile(e)}>
                  {' '}
                  {updateProfileSpinner ? (
                    <FormSpinner />
                  ) : (
                    `${lang?.Update}`
                  )}{' '}
                </button>
              </div>
            </form>
          ) : (
            <FormSpinner />
          )}
        </Modal>
      )}

      {/*delete featured product  */}
      <Modal
        ariaHideApp={false}
        isOpen={deleteFeaturedProduct}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
          },
          content: {
            position: 'absolute',
            top: '0',
            left: '0%',
            right: '0%',
            bottom: '200px',
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '8px',
            padding: '0',
            // outline: 'none',
          },
        }}
      >
        <div className="popup_header flex justify-between items-center popupheaderBg">
          <h4 className="page__title">Delete</h4>
          <button
            className="close_btn--modal"
            onClick={() => setDeleteFeaturedProduct(!deleteFeaturedProduct)}
          >
            {lang?.close}
          </button>
        </div>
        <div className="card card--block modal_box">
          <p className="warning">{lang?.are_you_sure}</p>
          <div className="right__btn text-right">
            <Link
              className="btn btn1"
              to="#"
              onClick={() => setDeleteFeaturedProduct(false)}
            >
              {lang?.Cancel}
            </Link>
            <Link
              className="btn btn2 ml-3"
              to="#"
              onClick={() => deleteFeatureList(featuredProductId)}
            >
              {featuredProductSpinner ? <FormSpinner /> : `${lang?.ok}`}
            </Link>
          </div>
        </div>
      </Modal>

      {/* user photos view */}
      {isOpenImage && (
        <div className="image--light--pop">
          <ReactImageVideoLightbox
            data={userPhotosData}
            startIndex={imageIndex}
            showResourceCount={true}
            onCloseCallback={() => {
              setIsOpenImage(false);
              setImageIndex(0);
            }}
            // onNavigationCallback={(currentIndex) =>
            //     console.log(`Current index: ${currentIndex}`)
            // }
          />
        </div>
      )}

      {coverPhotoSizeError && (
        <Modal
          className=""
          ariaHideApp={false}
          isOpen={coverPhotoSizeError}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
            },
            content: {
              position: 'absolute',
              top: '0',
              left: '0%',
              right: '0%',
              bottom: '200px',
              border: '1px solid #ccc',
              background: '#fff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              borderRadius: '4px',
              padding: '0px',
              // outline: 'none',
            },
          }}
        >
          <div className="popup_header flex justify-between items-center">
            <h4 className="page__title">{lang?.coverImageWidthInvalidHead}</h4>
            <button
              className="close_btn--modal"
              onClick={() => setCoverPhotoSizeError(!coverPhotoSizeError)}
            >
              {' '}
              {lang?.close}
            </button>
          </div>
          <div className="card card--block modal_box">
            <div className="crop_img_block">
              <h3>{lang?.coverImageWidthInvalidMessage}</h3>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
}
